export const invoiceTypes = [{
  label: '全部发票',
  id: "-1"
},{
    label: '电子发票（增值税专用发票）',
    id: '1'
  },
  {
    label: '电子发票（普通发票）',
    id: '2',
  },
  {
    label: '增值税专用发票',
    id: '3'
  },
  {
    label: '增值税电子专用发票',
    id: '4'
  },
  {
    label: '增值税普通发票',
    id: '5'
  },
  {
    label: '增值税电子普通发票',
    id: '6'
  },
  {
    label: '卷式发票',
    id: '7'
  },
  {
    label: '通行费发票',
    id: '8'
  },
  {
    label: '机动车销售统一发票',
    id: '9'
  },
  {
    label: '二手车销售统一发票',
    id: '10'
  },
  {
    label: '通用定额发票',
    id: '11'
  },
  {
    label: '其他发票',
    id: '12'
  },
  {
    label: '数电票(增值税专用发票) ',
    id: '13'
  },
  {
    label: '数电票(普通发票)',
    id: '14'
  },
  {
    label: '增值税普通发票(卷式) ',
    id: '15'
  },
  {
    label: '道路通行费电子普通发票',
    id: '16'
  },
  {
    label: '数电票(机动车销售统一发票)',
    id: '17'
  },
  {
    label: '数电票(二手车销售统一发票)',
    id: '18'
  },
  {
    label: '数电纸质发票(增值税专用发票)',
    id: '19'
  },
  {
    label: '数电纸质发票(普通发票)',
    id: '20'
  },
  {
    label: '数电纸质发票(机动车销售统一发票)',
    id: '21'
  },
  {
    label: '数电纸质发票(二手车销售统一发票)',
    id: '22'
  },
  {
    label: '数电票(航空运输电子客票行程单)',
    id: '23'
  },
  {
    label: '数电票(铁路电子客票)',
    id: '24'
  },
]
// 发票来源
export const invoiceSourceObj = {
  2: "导入",
  3: "手动新增",
  5: "crm同步",
}
function arrayToThree(sourceArr,parentIdName) {
  if(!sourceArr && !sourceArr.length) {
    throw new Error("传入值为空！")
  }
  const PARENT_ID_NAME = parentIdName || 'parentId'
  let arrThree = [];
  let getThree = function(three) {
    three.forEach(node=> {
      node.children = sourceArr.filter(childrenNode => childrenNode[PARENT_ID_NAME] === node.id);
      if(node.children.length) {
        getThree(node.children)
      }
    })
  }
  /* 先找出第一层级的数据，第一层级的数据 */
  let idList = sourceArr.map(i=> i.id);
  for(let i=0;i<sourceArr.length;i++) {
    if(!idList.includes(sourceArr[i][PARENT_ID_NAME])) {
      arrThree.push(sourceArr[i]);
    }
  }

  // 递归转换three
  getThree(arrThree);
  return arrThree;
}

export const b = [{
  "id": "-1",
  "parent": "#",
  "text": "请选择"
}, {
  "id": "1",
  "parent": "#",
  "text": "刑事案由"
}, {
  "id": "2",
  "parent": "1",
  "text": "危害国家安全罪"
}, {
  "id": "3",
  "parent": "2",
  "text": "背叛国家罪"
}, {
  "id": "4",
  "parent": "2",
  "text": "分裂国家罪"
}, {
  "id": "5",
  "parent": "2",
  "text": "煽动分裂国家罪"
}, {
  "id": "6",
  "parent": "2",
  "text": "武装叛乱、暴乱罪"
}, {
  "id": "7",
  "parent": "2",
  "text": "颠覆国家政权罪"
}, {
  "id": "8",
  "parent": "2",
  "text": "煽动颠覆国家政权罪"
}, {
  "id": "9",
  "parent": "2",
  "text": "资助危害国家安全犯罪活动罪"
}, {
  "id": "10",
  "parent": "2",
  "text": "投敌叛变罪"
}, {
  "id": "11",
  "parent": "2",
  "text": "叛逃罪"
}, {
  "id": "12",
  "parent": "2",
  "text": "间谍罪"
}, {
  "id": "13",
  "parent": "2",
  "text": "为境外窃取、刺探、收买、非法提供国家秘密、情报罪"
}, {
  "id": "14",
  "parent": "2",
  "text": "资敌罪"
}, {
  "id": "15",
  "parent": "1",
  "text": "危害公共安全罪"
}, {
  "id": "16",
  "parent": "15",
  "text": "放火罪"
}, {
  "id": "17",
  "parent": "15",
  "text": "决水罪"
}, {
  "id": "18",
  "parent": "15",
  "text": "爆炸罪"
}, {
  "id": "19",
  "parent": "15",
  "text": "投毒罪"
}, {
  "id": "4120",
  "parent": "15",
  "text": "投放危险物质罪"
}, {
  "id": "20",
  "parent": "15",
  "text": "以危险方法危害公共安全罪"
}, {
  "id": "21",
  "parent": "15",
  "text": "失火罪"
}, {
  "id": "22",
  "parent": "15",
  "text": "过失决水罪"
}, {
  "id": "23",
  "parent": "15",
  "text": "过失爆炸罪"
}, {
  "id": "24",
  "parent": "15",
  "text": "过失投毒罪"
}, {
  "id": "4121",
  "parent": "15",
  "text": "过失投放危险物质罪"
}, {
  "id": "25",
  "parent": "15",
  "text": "过失以危险方法危害公共安全罪"
}, {
  "id": "26",
  "parent": "15",
  "text": "破坏交通工具罪"
}, {
  "id": "27",
  "parent": "15",
  "text": "破坏交通设施罪"
}, {
  "id": "28",
  "parent": "15",
  "text": "破坏电力设备罪"
}, {
  "id": "29",
  "parent": "15",
  "text": "破坏易燃易爆设备罪"
}, {
  "id": "30",
  "parent": "15",
  "text": "过失损坏交通工具罪"
}, {
  "id": "31",
  "parent": "15",
  "text": "过失损坏交通设施罪"
}, {
  "id": "32",
  "parent": "15",
  "text": "过失损坏电力设备罪"
}, {
  "id": "33",
  "parent": "15",
  "text": "过失损坏易燃易爆设备罪"
}, {
  "id": "34",
  "parent": "15",
  "text": "组织、领导、参加恐怖组织罪"
}, {
  "id": "4122",
  "parent": "15",
  "text": "资助恐怖活动罪"
}, {
  "id": "4200",
  "parent": "15",
  "text": "帮助恐怖活动罪"
}, {
  "id": "4227",
  "parent": "15",
  "text": "准备实施恐怖活动罪"
}, {
  "id": "4225",
  "parent": "15",
  "text": "宣扬恐怖主义、极端主义、煽动实施恐怖活动罪"
}, {
  "id": "4214",
  "parent": "15",
  "text": "利用极端主义破坏法律实施罪"
}, {
  "id": "4217",
  "parent": "15",
  "text": "强制穿戴宣扬恐怖主义、极端主义服饰、标志罪"
}, {
  "id": "4206",
  "parent": "15",
  "text": "非法持有宣扬恐怖主义、极端主义物品罪"
}, {
  "id": "35",
  "parent": "15",
  "text": "劫持航空器罪"
}, {
  "id": "36",
  "parent": "15",
  "text": "劫持船只、汽车罪"
}, {
  "id": "37",
  "parent": "15",
  "text": "暴力危及飞行安全罪"
}, {
  "id": "38",
  "parent": "15",
  "text": "破坏广播电视设施、公用电信设施罪"
}, {
  "id": "39",
  "parent": "15",
  "text": "过失损坏广播电视设施、公用电信设施罪"
}, {
  "id": "40",
  "parent": "15",
  "text": "非法制造、买卖、运输、邮寄、储存枪支、弹药、爆炸物罪"
}, {
  "id": "41",
  "parent": "15",
  "text": "非法买卖、运输核材料罪"
}, {
  "id": "4123",
  "parent": "15",
  "text": "非法制造、买卖、运输、储存危险物质罪"
}, {
  "id": "42",
  "parent": "15",
  "text": "违规制造、销售枪支罪"
}, {
  "id": "43",
  "parent": "15",
  "text": "盗窃、抢夺枪支、弹药、爆炸物罪"
}, {
  "id": "4124",
  "parent": "15",
  "text": "盗窃、抢夺枪支、弹药、爆炸物、危险物质罪"
}, {
  "id": "44",
  "parent": "15",
  "text": "抢劫枪支、弹药、爆炸物罪"
}, {
  "id": "4125",
  "parent": "15",
  "text": "抢劫枪支、弹药、爆炸物、危险物质罪"
}, {
  "id": "45",
  "parent": "15",
  "text": "非法持有、私藏枪支、弹药罪"
}, {
  "id": "46",
  "parent": "15",
  "text": "非法出租、出借枪支罪"
}, {
  "id": "47",
  "parent": "15",
  "text": "丢失枪支不报罪"
}, {
  "id": "48",
  "parent": "15",
  "text": "非法携带枪支、弹药、管制刀具、危险物品危及公共安全罪"
}, {
  "id": "49",
  "parent": "15",
  "text": "重大飞行事故罪"
}, {
  "id": "50",
  "parent": "15",
  "text": "铁路运营安全事故罪"
}, {
  "id": "51",
  "parent": "15",
  "text": "交通肇事罪"
}, {
  "id": "4180",
  "parent": "15",
  "text": "危险驾驶罪"
}, {
  "id": "52",
  "parent": "15",
  "text": "重大责任事故罪"
}, {
  "id": "4140",
  "parent": "15",
  "text": "强令违章冒险作业罪"
}, {
  "id": "53",
  "parent": "15",
  "text": "重大劳动安全事故罪"
}, {
  "id": "4141",
  "parent": "15",
  "text": "大型群众性活动重大安全事故罪"
}, {
  "id": "54",
  "parent": "15",
  "text": "危险物品肇事罪"
}, {
  "id": "55",
  "parent": "15",
  "text": "工程重大安全事故罪"
}, {
  "id": "56",
  "parent": "15",
  "text": "教育设施重大安全事故罪"
}, {
  "id": "57",
  "parent": "15",
  "text": "消防责任事故罪"
}, {
  "id": "4142",
  "parent": "15",
  "text": "不报、谎报安全事故罪"
}, {
  "id": "58",
  "parent": "1",
  "text": "破坏社会主义市场经济秩序罪"
}, {
  "id": "59",
  "parent": "58",
  "text": "生产、销售伪劣商品罪"
}, {
  "id": "60",
  "parent": "59",
  "text": "生产、销售伪劣产品罪"
}, {
  "id": "61",
  "parent": "59",
  "text": "生产、销售假药罪"
}, {
  "id": "62",
  "parent": "59",
  "text": "生产、销售劣药罪"
}, {
  "id": "63",
  "parent": "59",
  "text": "生产、销售不符合卫生标准的食品罪"
}, {
  "id": "4181",
  "parent": "59",
  "text": "生产、销售不符合安全标准的食品罪"
}, {
  "id": "64",
  "parent": "59",
  "text": "生产、销售有毒、有害食品罪"
}, {
  "id": "65",
  "parent": "59",
  "text": "生产、销售不符合标准的医用器材罪"
}, {
  "id": "66",
  "parent": "59",
  "text": "生产、销售不符合安全标准的产品罪"
}, {
  "id": "67",
  "parent": "59",
  "text": "生产、销售伪劣农药、兽药、化肥、种子罪"
}, {
  "id": "68",
  "parent": "59",
  "text": "生产、销售不符合卫生标准的化妆品罪"
}, {
  "id": "69",
  "parent": "58",
  "text": "走私罪"
}, {
  "id": "70",
  "parent": "69",
  "text": "走私武器、弹药罪"
}, {
  "id": "71",
  "parent": "69",
  "text": "走私核材料罪"
}, {
  "id": "72",
  "parent": "69",
  "text": "走私假币罪"
}, {
  "id": "73",
  "parent": "69",
  "text": "走私文物罪"
}, {
  "id": "74",
  "parent": "69",
  "text": "走私贵重金属罪"
}, {
  "id": "75",
  "parent": "69",
  "text": "走私珍贵动物、珍贵动物制品罪"
}, {
  "id": "76",
  "parent": "69",
  "text": "走私珍稀植物、珍稀植物制品罪"
}, {
  "id": "4167",
  "parent": "69",
  "text": "走私国家禁止进出口的货物、物品罪"
}, {
  "id": "77",
  "parent": "69",
  "text": "走私淫秽物品罪"
}, {
  "id": "79",
  "parent": "69",
  "text": "走私废物罪"
}, {
  "id": "4231",
  "parent": "69",
  "text": "走私固体废物罪"
}, {
  "id": "78",
  "parent": "69",
  "text": "走私普通货物、物品罪"
}, {
  "id": "80",
  "parent": "58",
  "text": "妨害对公司、企业的管理秩序罪"
}, {
  "id": "81",
  "parent": "80",
  "text": "虚报注册资本罪"
}, {
  "id": "82",
  "parent": "80",
  "text": "虚假出资、抽逃出资罪"
}, {
  "id": "83",
  "parent": "80",
  "text": "欺诈发行股票、债券罪"
}, {
  "id": "84",
  "parent": "80",
  "text": "提供虚假财会报告罪"
}, {
  "id": "4143",
  "parent": "80",
  "text": "违规披露、不披露重要信息罪"
}, {
  "id": "85",
  "parent": "80",
  "text": "妨害清算罪"
}, {
  "id": "4086",
  "parent": "80",
  "text": "隐匿、故意销毁会计资料罪"
}, {
  "id": "4135",
  "parent": "80",
  "text": "隐匿、故意销毁会计凭证、会计账簿、财务会计报告罪"
}, {
  "id": "4144",
  "parent": "80",
  "text": "虚假破产罪"
}, {
  "id": "86",
  "parent": "80",
  "text": "公司、企业人员受贿罪"
}, {
  "id": "4145",
  "parent": "80",
  "text": "非国家工作人员受贿罪"
}, {
  "id": "87",
  "parent": "80",
  "text": "对公司、企业人员行贿罪"
}, {
  "id": "4146",
  "parent": "80",
  "text": "对非国家工作人员行贿罪"
}, {
  "id": "4182",
  "parent": "80",
  "text": "对外国公职人员、国际公共组织官员行贿罪"
}, {
  "id": "88",
  "parent": "80",
  "text": "非法经营同类营业罪"
}, {
  "id": "89",
  "parent": "80",
  "text": "为亲友非法牟利罪"
}, {
  "id": "90",
  "parent": "80",
  "text": "签订、履行合同失职罪"
}, {
  "id": "4192",
  "parent": "80",
  "text": "签订、履行合同失职被骗罪"
}, {
  "id": "4092",
  "parent": "80",
  "text": "国有公司、企业、事业单位人员失职罪"
}, {
  "id": "4093",
  "parent": "80",
  "text": "国有公司、企业、事业单位人员滥用职权罪"
}, {
  "id": "91",
  "parent": "80",
  "text": "徇私舞弊造成破产、亏损罪"
}, {
  "id": "92",
  "parent": "80",
  "text": "徇私舞弊低价折股、出售国有资产罪"
}, {
  "id": "4147",
  "parent": "80",
  "text": "操纵上市公司罪"
}, {
  "id": "4148",
  "parent": "80",
  "text": "指使操纵上市公司罪"
}, {
  "id": "4162",
  "parent": "80",
  "text": "背信损害上市公司利益罪"
}, {
  "id": "93",
  "parent": "58",
  "text": "破坏金融管理秩序罪"
}, {
  "id": "94",
  "parent": "93",
  "text": "伪造货币罪"
}, {
  "id": "95",
  "parent": "93",
  "text": "出售、购买、运输假币罪"
}, {
  "id": "96",
  "parent": "93",
  "text": "金融工作人员购买假币、以假币换取货币罪"
}, {
  "id": "97",
  "parent": "93",
  "text": "持有、使用假币罪"
}, {
  "id": "98",
  "parent": "93",
  "text": "变造货币罪"
}, {
  "id": "99",
  "parent": "93",
  "text": "擅自设立金融机构罪"
}, {
  "id": "100",
  "parent": "93",
  "text": "伪造、变造、转让金融机构经营许可证、批准文件罪"
}, {
  "id": "4232",
  "parent": "93",
  "text": "伪造、变造、转让金融机构经营许可证罪"
}, {
  "id": "101",
  "parent": "93",
  "text": "高利转贷罪"
}, {
  "id": "4149",
  "parent": "93",
  "text": "骗取贷款、票据承兑、金融票证罪"
}, {
  "id": "102",
  "parent": "93",
  "text": "非法吸收公众存款罪"
}, {
  "id": "103",
  "parent": "93",
  "text": "伪造、变造金融票证罪"
}, {
  "id": "4150",
  "parent": "93",
  "text": "妨害信用卡管理罪"
}, {
  "id": "4151",
  "parent": "93",
  "text": "窃取、收买、非法提供信用卡信息罪"
}, {
  "id": "104",
  "parent": "93",
  "text": "伪造、变造国家有价证券罪"
}, {
  "id": "105",
  "parent": "93",
  "text": "伪造、变造股票、公司、企业债券罪"
}, {
  "id": "106",
  "parent": "93",
  "text": "擅自发行股票、公司、企业债券罪"
}, {
  "id": "107",
  "parent": "93",
  "text": "内幕交易、泄露内幕信息罪"
}, {
  "id": "4168",
  "parent": "93",
  "text": "利用未公开信息交易罪"
}, {
  "id": "108",
  "parent": "93",
  "text": "编造并传播证券、期货交易虚假信息罪"
}, {
  "id": "4233",
  "parent": "93",
  "text": "编造并传播证券交易虚假信息罪"
}, {
  "id": "109",
  "parent": "93",
  "text": "诱骗投资者买卖证券、期货合约罪"
}, {
  "id": "4234",
  "parent": "93",
  "text": "诱骗投资者买卖证券罪"
}, {
  "id": "110",
  "parent": "93",
  "text": "操纵证券、期货交易价格罪"
}, {
  "id": "4235",
  "parent": "93",
  "text": "操纵证券交易价格罪"
}, {
  "id": "4163",
  "parent": "93",
  "text": "操纵证券、期货市场罪"
}, {
  "id": "4164",
  "parent": "93",
  "text": "背信运用受托财产罪"
}, {
  "id": "4165",
  "parent": "93",
  "text": "违法运用资金罪"
}, {
  "id": "111",
  "parent": "93",
  "text": "违法向关系人发放贷款罪"
}, {
  "id": "112",
  "parent": "93",
  "text": "违法发放贷款罪"
}, {
  "id": "113",
  "parent": "93",
  "text": "用账外客户资金非法拆借、发放贷款罪"
}, {
  "id": "4152",
  "parent": "93",
  "text": "吸收客户资金不入账罪"
}, {
  "id": "114",
  "parent": "93",
  "text": "非法出具金融票证罪"
}, {
  "id": "4166",
  "parent": "93",
  "text": "违规出具金融票证罪"
}, {
  "id": "115",
  "parent": "93",
  "text": "对违法票据承兑、付款、保证罪"
}, {
  "id": "116",
  "parent": "93",
  "text": "逃汇罪"
}, {
  "id": "117",
  "parent": "93",
  "text": "洗钱罪"
}, {
  "id": "4119",
  "parent": "93",
  "text": "骗购外汇罪"
}, {
  "id": "118",
  "parent": "58",
  "text": "金融诈骗罪"
}, {
  "id": "119",
  "parent": "118",
  "text": "集资诈骗罪"
}, {
  "id": "120",
  "parent": "118",
  "text": "贷款诈骗罪"
}, {
  "id": "121",
  "parent": "118",
  "text": "票据诈骗罪"
}, {
  "id": "122",
  "parent": "118",
  "text": "金融凭证诈骗罪"
}, {
  "id": "123",
  "parent": "118",
  "text": "信用证诈骗罪"
}, {
  "id": "124",
  "parent": "118",
  "text": "信用卡诈骗罪"
}, {
  "id": "125",
  "parent": "118",
  "text": "有价证券诈骗罪"
}, {
  "id": "126",
  "parent": "118",
  "text": "保险诈骗罪"
}, {
  "id": "127",
  "parent": "58",
  "text": "危害税收征管罪"
}, {
  "id": "128",
  "parent": "127",
  "text": "偷税罪"
}, {
  "id": "4169",
  "parent": "127",
  "text": "逃税罪"
}, {
  "id": "129",
  "parent": "127",
  "text": "抗税罪"
}, {
  "id": "130",
  "parent": "127",
  "text": "逃避追缴欠税罪"
}, {
  "id": "131",
  "parent": "127",
  "text": "骗取出口退税罪"
}, {
  "id": "132",
  "parent": "127",
  "text": "虚开增值税专用发票、用于骗取出口退税、抵扣税款发票罪"
}, {
  "id": "4184",
  "parent": "127",
  "text": "虚开发票罪"
}, {
  "id": "133",
  "parent": "127",
  "text": "伪造、出售伪造的增值税专用发票罪"
}, {
  "id": "134",
  "parent": "127",
  "text": "非法出售增值税专用发票罪"
}, {
  "id": "135",
  "parent": "127",
  "text": "非法购买增值税专用发票、购买伪造的增值税专用发票罪"
}, {
  "id": "136",
  "parent": "127",
  "text": "非法制造、出售非法制造的用于骗取出口退税、抵扣税款发票罪"
}, {
  "id": "137",
  "parent": "127",
  "text": "非法制造、出售非法制造的发票罪"
}, {
  "id": "138",
  "parent": "127",
  "text": "非法出售用于骗取出口退税、抵扣税款发票罪"
}, {
  "id": "139",
  "parent": "127",
  "text": "非法出售发票罪"
}, {
  "id": "4183",
  "parent": "127",
  "text": "持有伪造的发票罪"
}, {
  "id": "140",
  "parent": "58",
  "text": "侵犯知识产权罪"
}, {
  "id": "141",
  "parent": "140",
  "text": "假冒注册商标罪"
}, {
  "id": "142",
  "parent": "140",
  "text": "销售假冒注册商标的商品罪"
}, {
  "id": "143",
  "parent": "140",
  "text": "非法制造、销售非法制造的注册商标标识罪"
}, {
  "id": "144",
  "parent": "140",
  "text": "假冒专利罪"
}, {
  "id": "145",
  "parent": "140",
  "text": "侵犯著作权罪"
}, {
  "id": "146",
  "parent": "140",
  "text": "销售侵权复制品罪"
}, {
  "id": "147",
  "parent": "140",
  "text": "侵犯商业秘密罪"
}, {
  "id": "148",
  "parent": "58",
  "text": "扰乱市场秩序罪"
}, {
  "id": "149",
  "parent": "148",
  "text": "损害商业信誉、商品声誉罪"
}, {
  "id": "150",
  "parent": "148",
  "text": "虚假广告罪"
}, {
  "id": "151",
  "parent": "148",
  "text": "串通投标罪"
}, {
  "id": "152",
  "parent": "148",
  "text": "合同诈骗罪"
}, {
  "id": "4170",
  "parent": "148",
  "text": "组织、领导传销活动罪"
}, {
  "id": "153",
  "parent": "148",
  "text": "非法经营罪"
}, {
  "id": "154",
  "parent": "148",
  "text": "强迫交易罪"
}, {
  "id": "155",
  "parent": "148",
  "text": "伪造、倒卖伪造的有价票证罪"
}, {
  "id": "156",
  "parent": "148",
  "text": "倒卖车票、船票罪"
}, {
  "id": "157",
  "parent": "148",
  "text": "非法转让、倒卖土地使用权罪"
}, {
  "id": "158",
  "parent": "148",
  "text": "中介组织人员提供虚假证明文件罪"
}, {
  "id": "159",
  "parent": "148",
  "text": "中介组织人员出具证明文件重大失实罪"
}, {
  "id": "4128",
  "parent": "148",
  "text": "提供虚假证明文件罪"
}, {
  "id": "4129",
  "parent": "148",
  "text": "出具证明文件重大失实罪"
}, {
  "id": "160",
  "parent": "148",
  "text": "逃避商检罪"
}, {
  "id": "161",
  "parent": "1",
  "text": "侵犯公民人身权利、民主权利罪"
}, {
  "id": "162",
  "parent": "161",
  "text": "故意杀人罪"
}, {
  "id": "163",
  "parent": "161",
  "text": "过失致人死亡罪"
}, {
  "id": "164",
  "parent": "161",
  "text": "故意伤害罪"
}, {
  "id": "4186",
  "parent": "161",
  "text": "组织出卖人体器官罪"
}, {
  "id": "165",
  "parent": "161",
  "text": "过失致人重伤罪"
}, {
  "id": "166",
  "parent": "161",
  "text": "强奸罪"
}, {
  "id": "167",
  "parent": "161",
  "text": "奸淫幼女罪"
}, {
  "id": "4218",
  "parent": "161",
  "text": "强制猥亵、侮辱罪"
}, {
  "id": "168",
  "parent": "161",
  "text": "强制猥亵、侮辱妇女罪"
}, {
  "id": "169",
  "parent": "161",
  "text": "猥亵儿童罪"
}, {
  "id": "170",
  "parent": "161",
  "text": "非法拘禁罪"
}, {
  "id": "171",
  "parent": "161",
  "text": "绑架罪"
}, {
  "id": "172",
  "parent": "161",
  "text": "拐卖妇女、儿童罪"
}, {
  "id": "173",
  "parent": "161",
  "text": "收买被拐卖的妇女、儿童罪"
}, {
  "id": "174",
  "parent": "161",
  "text": "聚众阻碍解救被收买的妇女、儿童罪"
}, {
  "id": "175",
  "parent": "161",
  "text": "诬告陷害罪"
}, {
  "id": "176",
  "parent": "161",
  "text": "强迫职工劳动罪"
}, {
  "id": "4185",
  "parent": "161",
  "text": "强迫劳动罪"
}, {
  "id": "4136",
  "parent": "161",
  "text": "雇用童工从事危重劳动罪"
}, {
  "id": "177",
  "parent": "161",
  "text": "非法搜查罪"
}, {
  "id": "178",
  "parent": "161",
  "text": "非法侵入住宅罪"
}, {
  "id": "179",
  "parent": "161",
  "text": "侮辱罪"
}, {
  "id": "180",
  "parent": "161",
  "text": "诽谤罪"
}, {
  "id": "181",
  "parent": "161",
  "text": "刑讯逼供罪"
}, {
  "id": "182",
  "parent": "161",
  "text": "暴力取证罪"
}, {
  "id": "183",
  "parent": "161",
  "text": "虐待被监管人罪"
}, {
  "id": "184",
  "parent": "161",
  "text": "煽动民族仇恨、民族歧视罪"
}, {
  "id": "185",
  "parent": "161",
  "text": "出版歧视、侮辱少数民族作品罪"
}, {
  "id": "186",
  "parent": "161",
  "text": "非法剥夺公民宗教信仰自由罪"
}, {
  "id": "187",
  "parent": "161",
  "text": "侵犯少数民族风俗习惯罪"
}, {
  "id": "188",
  "parent": "161",
  "text": "侵犯通信自由罪"
}, {
  "id": "189",
  "parent": "161",
  "text": "私自开拆、隐匿、毁弃邮件、电报罪"
}, {
  "id": "4171",
  "parent": "161",
  "text": "出售、非法提供公民个人信息罪"
}, {
  "id": "4172",
  "parent": "161",
  "text": "非法获取公民个人信息罪"
}, {
  "id": "4219",
  "parent": "161",
  "text": "侵犯公民个人信息罪"
}, {
  "id": "190",
  "parent": "161",
  "text": "报复陷害罪"
}, {
  "id": "191",
  "parent": "161",
  "text": "打击报复会计、统计人员罪"
}, {
  "id": "192",
  "parent": "161",
  "text": "破坏选举罪"
}, {
  "id": "193",
  "parent": "161",
  "text": "暴力干涉婚姻自由罪"
}, {
  "id": "194",
  "parent": "161",
  "text": "重婚罪"
}, {
  "id": "195",
  "parent": "161",
  "text": "破坏军婚罪"
}, {
  "id": "196",
  "parent": "161",
  "text": "虐待罪"
}, {
  "id": "4215",
  "parent": "161",
  "text": "虐待被监护、看护人罪"
}, {
  "id": "197",
  "parent": "161",
  "text": "遗弃罪"
}, {
  "id": "198",
  "parent": "161",
  "text": "拐骗儿童罪"
}, {
  "id": "4153",
  "parent": "161",
  "text": "组织残疾人、儿童乞讨罪"
}, {
  "id": "4173",
  "parent": "161",
  "text": "组织未成年人进行违反治安管理活动罪"
}, {
  "id": "199",
  "parent": "1",
  "text": "侵犯财产罪"
}, {
  "id": "200",
  "parent": "199",
  "text": "抢劫罪"
}, {
  "id": "201",
  "parent": "199",
  "text": "盗窃罪"
}, {
  "id": "202",
  "parent": "199",
  "text": "诈骗罪"
}, {
  "id": "203",
  "parent": "199",
  "text": "抢夺罪"
}, {
  "id": "204",
  "parent": "199",
  "text": "聚众哄抢罪"
}, {
  "id": "205",
  "parent": "199",
  "text": "侵占罪"
}, {
  "id": "206",
  "parent": "199",
  "text": "职务侵占罪"
}, {
  "id": "207",
  "parent": "199",
  "text": "挪用资金罪"
}, {
  "id": "208",
  "parent": "199",
  "text": "挪用特定款物罪"
}, {
  "id": "209",
  "parent": "199",
  "text": "敲诈勒索罪"
}, {
  "id": "210",
  "parent": "199",
  "text": "故意毁坏财物罪"
}, {
  "id": "211",
  "parent": "199",
  "text": "破坏生产经营罪"
}, {
  "id": "4187",
  "parent": "199",
  "text": "拒不支付劳动报酬罪"
}, {
  "id": "212",
  "parent": "1",
  "text": "妨害社会管理秩序罪"
}, {
  "id": "213",
  "parent": "212",
  "text": "扰乱公共秩序罪"
}, {
  "id": "214",
  "parent": "213",
  "text": "妨害公务罪"
}, {
  "id": "215",
  "parent": "213",
  "text": "煽动暴力抗拒法律实施罪"
}, {
  "id": "216",
  "parent": "213",
  "text": "招摇撞骗罪"
}, {
  "id": "217",
  "parent": "213",
  "text": "伪造、变造、买卖国家机关公文、证件、印章罪"
}, {
  "id": "218",
  "parent": "213",
  "text": "盗窃、抢夺、毁灭国家机关公文、证件、印章罪"
}, {
  "id": "219",
  "parent": "213",
  "text": "伪造公司、企业、事业单位、人民团体印章罪"
}, {
  "id": "220",
  "parent": "213",
  "text": "伪造、变造居民身份证罪"
}, {
  "id": "4222",
  "parent": "213",
  "text": "伪造、变造、买卖身份证件罪"
}, {
  "id": "4221",
  "parent": "213",
  "text": "使用虚假身份证件、盗用身份证件罪"
}, {
  "id": "221",
  "parent": "213",
  "text": "非法生产、买卖警用装备罪"
}, {
  "id": "222",
  "parent": "213",
  "text": "非法获取国家秘密罪"
}, {
  "id": "223",
  "parent": "213",
  "text": "非法持有国家绝密、机密文件、资料、物品罪"
}, {
  "id": "224",
  "parent": "213",
  "text": "非法生产、销售间谍专用器材罪"
}, {
  "id": "4211",
  "parent": "213",
  "text": "非法生产、销售专用间谍器材、窃听、窃照专用器材罪"
}, {
  "id": "225",
  "parent": "213",
  "text": "非法使用窃听、窃照专用器材罪"
}, {
  "id": "4230",
  "parent": "213",
  "text": "组织考试作弊罪"
}, {
  "id": "4207",
  "parent": "213",
  "text": "非法出售、提供试题、答案罪"
}, {
  "id": "4203",
  "parent": "213",
  "text": "代替考试罪"
}, {
  "id": "226",
  "parent": "213",
  "text": "非法侵入计算机信息系统罪"
}, {
  "id": "4174",
  "parent": "213",
  "text": "非法获取计算机信息系统数据、非法控制计算机信息系统罪"
}, {
  "id": "4175",
  "parent": "213",
  "text": "提供侵入、非法控制计算机信息系统程序、工具罪"
}, {
  "id": "227",
  "parent": "213",
  "text": "破坏计算机信息系统罪"
}, {
  "id": "4212",
  "parent": "213",
  "text": "拒不履行信息网络安全管理义务罪"
}, {
  "id": "4208",
  "parent": "213",
  "text": "非法利用信息网络罪"
}, {
  "id": "4201",
  "parent": "213",
  "text": "帮助信息网络犯罪活动罪"
}, {
  "id": "228",
  "parent": "213",
  "text": "扰乱无线电通讯管理秩序罪"
}, {
  "id": "229",
  "parent": "213",
  "text": "聚众扰乱社会秩序罪"
}, {
  "id": "230",
  "parent": "213",
  "text": "聚众冲击国家机关罪"
}, {
  "id": "4220",
  "parent": "213",
  "text": "扰乱国家机关工作秩序罪"
}, {
  "id": "4229",
  "parent": "213",
  "text": "组织、资助非法聚集罪"
}, {
  "id": "231",
  "parent": "213",
  "text": "聚众扰乱公共场所秩序、交通秩序罪"
}, {
  "id": "4130",
  "parent": "213",
  "text": "投放虚假危险物质罪"
}, {
  "id": "4131",
  "parent": "213",
  "text": "编造、故意传播虚假恐怖信息罪"
}, {
  "id": "4202",
  "parent": "213",
  "text": "编造、故意传播虚假信息罪"
}, {
  "id": "232",
  "parent": "213",
  "text": "聚众斗殴罪"
}, {
  "id": "233",
  "parent": "213",
  "text": "寻衅滋事罪"
}, {
  "id": "234",
  "parent": "213",
  "text": "组织、领导、参加黑社会性质组织罪"
}, {
  "id": "235",
  "parent": "213",
  "text": "入境发展黑社会组织罪"
}, {
  "id": "236",
  "parent": "213",
  "text": "包庇、纵容黑社会性质组织罪"
}, {
  "id": "237",
  "parent": "213",
  "text": "传授犯罪方法罪"
}, {
  "id": "238",
  "parent": "213",
  "text": "非法集会、游行、示威罪"
}, {
  "id": "239",
  "parent": "213",
  "text": "非法携带武器、管制刀具、爆炸物参加集会、游行、示威罪"
}, {
  "id": "240",
  "parent": "213",
  "text": "破坏集会、游行、示威罪"
}, {
  "id": "241",
  "parent": "213",
  "text": "侮辱国旗、国徽罪"
}, {
  "id": "242",
  "parent": "213",
  "text": "组织、利用会道门、邪教组织、利用迷信破坏法律实施罪"
}, {
  "id": "243",
  "parent": "213",
  "text": "组织、利用会道门、邪教组织、利用迷信致人死亡罪"
}, {
  "id": "4228",
  "parent": "213",
  "text": "组织、利用会道门、邪教组织、利用迷信致人重伤、死亡罪"
}, {
  "id": "244",
  "parent": "213",
  "text": "聚众淫乱罪"
}, {
  "id": "245",
  "parent": "213",
  "text": "引诱未成年人聚众淫乱罪"
}, {
  "id": "246",
  "parent": "213",
  "text": "盗窃、侮辱尸体罪"
}, {
  "id": "4204",
  "parent": "213",
  "text": "盗窃、侮辱、故意毁坏尸体、尸骨、骨灰罪"
}, {
  "id": "247",
  "parent": "213",
  "text": "赌博罪"
}, {
  "id": "4154",
  "parent": "213",
  "text": "开设赌场罪"
}, {
  "id": "248",
  "parent": "213",
  "text": "故意延误投递邮件罪"
}, {
  "id": "249",
  "parent": "212",
  "text": "妨害司法罪"
}, {
  "id": "250",
  "parent": "249",
  "text": "伪证罪"
}, {
  "id": "251",
  "parent": "249",
  "text": "辩护人、诉讼代理人毁灭证据、伪造证据、妨害作证罪"
}, {
  "id": "252",
  "parent": "249",
  "text": "妨害作证罪"
}, {
  "id": "253",
  "parent": "249",
  "text": "帮助毁灭、伪造证据罪"
}, {
  "id": "4224",
  "parent": "249",
  "text": "虚假诉讼罪"
}, {
  "id": "254",
  "parent": "249",
  "text": "打击报复证人罪"
}, {
  "id": "4223",
  "parent": "249",
  "text": "泄露不应公开的案件信息罪"
}, {
  "id": "4216",
  "parent": "249",
  "text": "披露、报道不应公开的案件信息罪"
}, {
  "id": "255",
  "parent": "249",
  "text": "扰乱法庭秩序罪"
}, {
  "id": "256",
  "parent": "249",
  "text": "窝藏、包庇罪"
}, {
  "id": "257",
  "parent": "249",
  "text": "拒绝提供间谍犯罪证据罪"
}, {
  "id": "4213",
  "parent": "249",
  "text": "拒绝提供间谍犯罪、恐怖主义犯罪、极端主义犯罪证据罪"
}, {
  "id": "258",
  "parent": "249",
  "text": "窝藏、转移、收购、销售赃物罪"
}, {
  "id": "4155",
  "parent": "249",
  "text": "隐瞒、掩饰犯罪所得、犯罪所得收益罪"
}, {
  "id": "4188",
  "parent": "249",
  "text": "掩饰、隐瞒犯罪所得、犯罪所得收益罪"
}, {
  "id": "259",
  "parent": "249",
  "text": "拒不执行判决、裁定罪"
}, {
  "id": "260",
  "parent": "249",
  "text": "非法处置查封、扣押、冻结的财产罪"
}, {
  "id": "261",
  "parent": "249",
  "text": "破坏监管秩序罪"
}, {
  "id": "262",
  "parent": "249",
  "text": "脱逃罪"
}, {
  "id": "263",
  "parent": "249",
  "text": "劫夺被押解人员罪"
}, {
  "id": "264",
  "parent": "249",
  "text": "组织越狱罪"
}, {
  "id": "265",
  "parent": "249",
  "text": "暴动越狱罪"
}, {
  "id": "266",
  "parent": "249",
  "text": "聚众持械劫狱罪"
}, {
  "id": "267",
  "parent": "212",
  "text": "妨害国(边)境管理罪"
}, {
  "id": "268",
  "parent": "267",
  "text": "组织他人偷越国(边)境罪"
}, {
  "id": "269",
  "parent": "267",
  "text": "骗取出境证件罪"
}, {
  "id": "270",
  "parent": "267",
  "text": "提供伪造、变造的出入境证件罪"
}, {
  "id": "271",
  "parent": "267",
  "text": "出售出入境证件罪"
}, {
  "id": "272",
  "parent": "267",
  "text": "运送他人偷越国(边)境罪"
}, {
  "id": "273",
  "parent": "267",
  "text": "偷越国(边)境罪"
}, {
  "id": "274",
  "parent": "267",
  "text": "破坏界碑、界桩罪"
}, {
  "id": "275",
  "parent": "267",
  "text": "破坏永久性测量标志罪"
}, {
  "id": "276",
  "parent": "212",
  "text": "妨害文物管理罪"
}, {
  "id": "277",
  "parent": "276",
  "text": "故意损毁文物罪"
}, {
  "id": "278",
  "parent": "276",
  "text": "故意损毁名胜古迹罪"
}, {
  "id": "279",
  "parent": "276",
  "text": "过失损毁文物罪"
}, {
  "id": "280",
  "parent": "276",
  "text": "非法向外国人出售、赠送珍贵文物罪"
}, {
  "id": "281",
  "parent": "276",
  "text": "倒卖文物罪"
}, {
  "id": "282",
  "parent": "276",
  "text": "非法出售、私赠文物藏品罪"
}, {
  "id": "283",
  "parent": "276",
  "text": "盗掘古文化遗址、古墓葬罪"
}, {
  "id": "284",
  "parent": "276",
  "text": "盗掘古人类化石、古脊椎动物化石罪"
}, {
  "id": "285",
  "parent": "276",
  "text": "抢夺、窃取国有档案罪"
}, {
  "id": "286",
  "parent": "276",
  "text": "擅自出卖、转让国有档案罪"
}, {
  "id": "287",
  "parent": "212",
  "text": "危害公共卫生罪"
}, {
  "id": "288",
  "parent": "287",
  "text": "违反传染病防治规定罪"
}, {
  "id": "4156",
  "parent": "287",
  "text": "妨害传染病防治罪"
}, {
  "id": "289",
  "parent": "287",
  "text": "传染病菌种、毒种扩散罪"
}, {
  "id": "290",
  "parent": "287",
  "text": "违反国境卫生检疫规定罪"
}, {
  "id": "4157",
  "parent": "287",
  "text": "妨害国境卫生检疫罪"
}, {
  "id": "291",
  "parent": "287",
  "text": "非法组织卖血罪"
}, {
  "id": "292",
  "parent": "287",
  "text": "强迫卖血罪"
}, {
  "id": "293",
  "parent": "287",
  "text": "非法采集、供应血液、制作、供应血液制品罪"
}, {
  "id": "294",
  "parent": "287",
  "text": "采集、供应血液、制作、供应血液制品事故罪"
}, {
  "id": "295",
  "parent": "287",
  "text": "医疗事故罪"
}, {
  "id": "296",
  "parent": "287",
  "text": "非法行医罪"
}, {
  "id": "297",
  "parent": "287",
  "text": "非法进行节育手术罪"
}, {
  "id": "298",
  "parent": "287",
  "text": "逃避动植物检疫罪"
}, {
  "id": "4176",
  "parent": "287",
  "text": "妨害动植物防疫、检疫罪"
}, {
  "id": "299",
  "parent": "212",
  "text": "破坏环境资源保护罪"
}, {
  "id": "300",
  "parent": "299",
  "text": "重大环境污染事故罪"
}, {
  "id": "4189",
  "parent": "299",
  "text": "污染环境罪"
}, {
  "id": "301",
  "parent": "299",
  "text": "非法处置进口的固体废物罪"
}, {
  "id": "302",
  "parent": "299",
  "text": "擅自进口固体废物罪"
}, {
  "id": "303",
  "parent": "299",
  "text": "非法捕捞水产品罪"
}, {
  "id": "304",
  "parent": "299",
  "text": "非法猎捕、杀害珍贵、濒危野生动物罪"
}, {
  "id": "305",
  "parent": "299",
  "text": "非法收购、运输、出售珍贵、濒危野生动物、珍贵、濒危野生动物制品罪"
}, {
  "id": "306",
  "parent": "299",
  "text": "非法狩猎罪"
}, {
  "id": "307",
  "parent": "299",
  "text": "非法占用耕地罪"
}, {
  "id": "4132",
  "parent": "299",
  "text": "非法占用农用地罪"
}, {
  "id": "308",
  "parent": "299",
  "text": "非法采矿罪"
}, {
  "id": "309",
  "parent": "299",
  "text": "破坏性采矿罪"
}, {
  "id": "310",
  "parent": "299",
  "text": "非法采伐、毁坏国家重点保护植物罪"
}, {
  "id": "4137",
  "parent": "299",
  "text": "非法收购、运输、加工、出售国家重点保护植物、国家重点保护植物制品罪"
}, {
  "id": "4236",
  "parent": "299",
  "text": "非法采伐、毁坏珍贵树木罪"
}, {
  "id": "311",
  "parent": "299",
  "text": "盗伐林木罪"
}, {
  "id": "312",
  "parent": "299",
  "text": "滥伐林木罪"
}, {
  "id": "313",
  "parent": "299",
  "text": "非法收购、运输盗伐、滥伐的林木罪"
}, {
  "id": "4237",
  "parent": "299",
  "text": "非法收购盗伐、滥伐的林木罪"
}, {
  "id": "314",
  "parent": "212",
  "text": "走私、贩卖、运输、制造毒品罪"
}, {
  "id": "315",
  "parent": "314",
  "text": "走私、贩卖、运输、制造毒品罪"
}, {
  "id": "316",
  "parent": "314",
  "text": "非法持有毒品罪"
}, {
  "id": "317",
  "parent": "314",
  "text": "包庇毒品犯罪分子罪"
}, {
  "id": "318",
  "parent": "314",
  "text": "窝藏、转移、隐瞒毒品、毒赃罪"
}, {
  "id": "319",
  "parent": "314",
  "text": "走私制毒物品罪"
}, {
  "id": "320",
  "parent": "314",
  "text": "非法买卖制毒物品罪"
}, {
  "id": "4210",
  "parent": "314",
  "text": "非法生产、买卖、运输制毒物品、走私制毒物品罪"
}, {
  "id": "321",
  "parent": "314",
  "text": "非法种植毒品原植物罪"
}, {
  "id": "322",
  "parent": "314",
  "text": "非法买卖、运输、携带、持有毒品原植物种子、幼苗罪"
}, {
  "id": "323",
  "parent": "314",
  "text": "引诱、教唆、欺骗他人吸毒罪"
}, {
  "id": "324",
  "parent": "314",
  "text": "强迫他人吸毒罪"
}, {
  "id": "325",
  "parent": "314",
  "text": "容留他人吸毒罪"
}, {
  "id": "326",
  "parent": "314",
  "text": "非法提供麻醉药品、精神药品罪"
}, {
  "id": "327",
  "parent": "212",
  "text": "组织、强迫、引诱、容留、介绍卖淫罪"
}, {
  "id": "328",
  "parent": "327",
  "text": "组织卖淫罪"
}, {
  "id": "329",
  "parent": "327",
  "text": "强迫卖淫罪"
}, {
  "id": "330",
  "parent": "327",
  "text": "协助组织卖淫罪"
}, {
  "id": "331",
  "parent": "327",
  "text": "引诱、容留、介绍卖淫罪"
}, {
  "id": "332",
  "parent": "327",
  "text": "引诱幼女卖淫罪"
}, {
  "id": "333",
  "parent": "327",
  "text": "传播性病罪"
}, {
  "id": "334",
  "parent": "327",
  "text": "嫖宿幼女罪"
}, {
  "id": "335",
  "parent": "212",
  "text": "制作、贩卖、传播淫秽物品罪"
}, {
  "id": "336",
  "parent": "335",
  "text": "制作、复制、出版、贩卖、传播淫秽物品牟利罪"
}, {
  "id": "337",
  "parent": "335",
  "text": "为他人提供书号出版淫秽书刊罪"
}, {
  "id": "338",
  "parent": "335",
  "text": "传播淫秽物品罪"
}, {
  "id": "339",
  "parent": "335",
  "text": "组织播放淫秽音像制品罪"
}, {
  "id": "340",
  "parent": "335",
  "text": "组织淫秽表演罪"
}, {
  "id": "341",
  "parent": "1",
  "text": "危害国防利益罪"
}, {
  "id": "342",
  "parent": "341",
  "text": "阻碍军人执行职务罪"
}, {
  "id": "343",
  "parent": "341",
  "text": "阻碍军事行动罪"
}, {
  "id": "4158",
  "parent": "341",
  "text": "过失破坏武器装备、军事设施、军事通信罪"
}, {
  "id": "344",
  "parent": "341",
  "text": "破坏武器装备、军事设施、军事通信罪"
}, {
  "id": "4190",
  "parent": "341",
  "text": "过失损坏武器装备、军事设施、军事通信罪"
}, {
  "id": "345",
  "parent": "341",
  "text": "故意提供不合格武器装备、军事设施罪"
}, {
  "id": "346",
  "parent": "341",
  "text": "过失提供不合格武器装备、军事设施罪"
}, {
  "id": "347",
  "parent": "341",
  "text": "聚众冲击军事禁区罪"
}, {
  "id": "348",
  "parent": "341",
  "text": "聚众扰乱军事管理区秩序罪"
}, {
  "id": "349",
  "parent": "341",
  "text": "冒充军人招摇撞骗罪"
}, {
  "id": "350",
  "parent": "341",
  "text": "煽动军人逃离部队罪"
}, {
  "id": "351",
  "parent": "341",
  "text": "雇用逃离部队军人罪"
}, {
  "id": "352",
  "parent": "341",
  "text": "接送不合格兵员罪"
}, {
  "id": "353",
  "parent": "341",
  "text": "伪造、变造、买卖武装部队公文、证件、印章罪"
}, {
  "id": "354",
  "parent": "341",
  "text": "盗窃、抢夺武装部队公文、证件、印章罪"
}, {
  "id": "355",
  "parent": "341",
  "text": "非法生产、买卖军用标志罪"
}, {
  "id": "4177",
  "parent": "341",
  "text": "非法生产、买卖武装部队制式服装罪"
}, {
  "id": "4178",
  "parent": "341",
  "text": "伪造、盗窃、买卖、非法提供、非法使用武装部队专用标志罪"
}, {
  "id": "356",
  "parent": "341",
  "text": "战时拒绝、逃避征召、军事训练罪"
}, {
  "id": "357",
  "parent": "341",
  "text": "战时拒绝、逃避服役罪"
}, {
  "id": "358",
  "parent": "341",
  "text": "战时故意提供虚假敌情罪"
}, {
  "id": "359",
  "parent": "341",
  "text": "战时造谣扰乱军心罪"
}, {
  "id": "360",
  "parent": "341",
  "text": "战时窝藏逃离部队军人罪"
}, {
  "id": "361",
  "parent": "341",
  "text": "战时拒绝、故意延误军事订货罪"
}, {
  "id": "362",
  "parent": "341",
  "text": "战时拒绝军事征用罪"
}, {
  "id": "4226",
  "parent": "341",
  "text": "战时拒绝军事征收、征用罪"
}, {
  "id": "363",
  "parent": "1",
  "text": "贪污贿赂罪"
}, {
  "id": "364",
  "parent": "363",
  "text": "贪污罪"
}, {
  "id": "365",
  "parent": "363",
  "text": "挪用公款罪"
}, {
  "id": "366",
  "parent": "363",
  "text": "受贿罪"
}, {
  "id": "367",
  "parent": "363",
  "text": "单位受贿罪"
}, {
  "id": "4179",
  "parent": "363",
  "text": "利用影响力受贿罪"
}, {
  "id": "368",
  "parent": "363",
  "text": "行贿罪"
}, {
  "id": "4205",
  "parent": "363",
  "text": "对有影响力的人行贿罪"
}, {
  "id": "369",
  "parent": "363",
  "text": "对单位行贿罪"
}, {
  "id": "370",
  "parent": "363",
  "text": "介绍贿赂罪"
}, {
  "id": "371",
  "parent": "363",
  "text": "单位行贿罪"
}, {
  "id": "372",
  "parent": "363",
  "text": "巨额财产来源不明罪"
}, {
  "id": "373",
  "parent": "363",
  "text": "隐瞒境外存款罪"
}, {
  "id": "374",
  "parent": "363",
  "text": "私分国有资产罪"
}, {
  "id": "375",
  "parent": "363",
  "text": "私分罚没财物罪"
}, {
  "id": "376",
  "parent": "1",
  "text": "渎职罪"
}, {
  "id": "377",
  "parent": "376",
  "text": "滥用职权罪"
}, {
  "id": "378",
  "parent": "376",
  "text": "玩忽职守罪"
}, {
  "id": "379",
  "parent": "376",
  "text": "故意泄露国家秘密罪"
}, {
  "id": "380",
  "parent": "376",
  "text": "过失泄露国家秘密罪"
}, {
  "id": "381",
  "parent": "376",
  "text": "徇私枉法罪"
}, {
  "id": "382",
  "parent": "376",
  "text": "枉法裁判罪"
}, {
  "id": "4133",
  "parent": "376",
  "text": "民事、行政枉法裁判罪"
}, {
  "id": "4138",
  "parent": "376",
  "text": "执行判决、裁定失职罪"
}, {
  "id": "4139",
  "parent": "376",
  "text": "执行判决、裁定滥用职权罪"
}, {
  "id": "4159",
  "parent": "376",
  "text": "枉法仲裁罪"
}, {
  "id": "383",
  "parent": "376",
  "text": "私放在押人员罪"
}, {
  "id": "384",
  "parent": "376",
  "text": "失职致使在押人员脱逃罪"
}, {
  "id": "385",
  "parent": "376",
  "text": "徇私舞弊减刑、假释、暂予监外执行罪"
}, {
  "id": "386",
  "parent": "376",
  "text": "徇私舞弊不移交刑事案件罪"
}, {
  "id": "387",
  "parent": "376",
  "text": "滥用管理公司、证券职权罪"
}, {
  "id": "388",
  "parent": "376",
  "text": "徇私舞弊不征、少征税款罪"
}, {
  "id": "389",
  "parent": "376",
  "text": "徇私舞弊发售发票、抵扣税款、出口退税罪"
}, {
  "id": "809",
  "parent": "376",
  "text": "违法提供出口退税凭证罪"
}, {
  "id": "390",
  "parent": "376",
  "text": "国家机关工作人员签订、履行合同失职罪"
}, {
  "id": "4134",
  "parent": "376",
  "text": "国家机关工作人员签订、履行合同失职被骗罪"
}, {
  "id": "391",
  "parent": "376",
  "text": "违法发放林木采伐许可证罪"
}, {
  "id": "392",
  "parent": "376",
  "text": "环境监管失职罪"
}, {
  "id": "4191",
  "parent": "376",
  "text": "食品监管渎职罪"
}, {
  "id": "393",
  "parent": "376",
  "text": "传染病防治失职罪"
}, {
  "id": "394",
  "parent": "376",
  "text": "非法批准征用、占用土地罪"
}, {
  "id": "4209",
  "parent": "376",
  "text": "非法批准征收、征用、占用土地罪"
}, {
  "id": "810",
  "parent": "376",
  "text": "非法低价出让国有土地使用权罪"
}, {
  "id": "395",
  "parent": "376",
  "text": "放纵走私罪"
}, {
  "id": "396",
  "parent": "376",
  "text": "商检徇私舞弊罪"
}, {
  "id": "397",
  "parent": "376",
  "text": "商检失职罪"
}, {
  "id": "398",
  "parent": "376",
  "text": "动植物检疫徇私舞弊罪"
}, {
  "id": "399",
  "parent": "376",
  "text": "动植物检疫失职罪"
}, {
  "id": "400",
  "parent": "376",
  "text": "放纵制售伪劣商品犯罪行为罪"
}, {
  "id": "401",
  "parent": "376",
  "text": "办理偷越国(边)境人员出入境证件罪"
}, {
  "id": "402",
  "parent": "376",
  "text": "放行偷越国(边)境人员罪"
}, {
  "id": "403",
  "parent": "376",
  "text": "不解救被拐卖、绑架妇女、儿童罪"
}, {
  "id": "404",
  "parent": "376",
  "text": "阻碍解救被拐卖、绑架妇女、儿童罪"
}, {
  "id": "405",
  "parent": "376",
  "text": "帮助罪犯逃避处罚罪"
}, {
  "id": "4160",
  "parent": "376",
  "text": "帮助犯罪分子逃避处罚罪"
}, {
  "id": "406",
  "parent": "376",
  "text": "招收公务员、学生徇私舞弊罪"
}, {
  "id": "407",
  "parent": "376",
  "text": "失职造成珍贵文物损毁、流失罪"
}, {
  "id": "408",
  "parent": "1",
  "text": "军人违反职责罪"
}, {
  "id": "409",
  "parent": "408",
  "text": "战时违抗命令罪"
}, {
  "id": "410",
  "parent": "408",
  "text": "隐瞒、谎报军情罪"
}, {
  "id": "411",
  "parent": "408",
  "text": "拒传、假传军令罪"
}, {
  "id": "412",
  "parent": "408",
  "text": "投降罪"
}, {
  "id": "413",
  "parent": "408",
  "text": "战时临阵脱逃罪"
}, {
  "id": "414",
  "parent": "408",
  "text": "擅离、玩忽军事职守罪"
}, {
  "id": "415",
  "parent": "408",
  "text": "阻碍执行军事职务罪"
}, {
  "id": "416",
  "parent": "408",
  "text": "指使部属违反职责罪"
}, {
  "id": "417",
  "parent": "408",
  "text": "违令作战消极罪"
}, {
  "id": "418",
  "parent": "408",
  "text": "拒不救援友邻部队罪"
}, {
  "id": "419",
  "parent": "408",
  "text": "军人叛逃罪"
}, {
  "id": "420",
  "parent": "408",
  "text": "非法获取军事秘密罪"
}, {
  "id": "421",
  "parent": "408",
  "text": "为境外窃取、刺探、收买、非法提供军事秘密罪"
}, {
  "id": "422",
  "parent": "408",
  "text": "故意泄露军事秘密罪"
}, {
  "id": "423",
  "parent": "408",
  "text": "过失泄露军事秘密罪"
}, {
  "id": "424",
  "parent": "408",
  "text": "战时军人造谣惑众罪"
}, {
  "id": "4161",
  "parent": "408",
  "text": "战时造谣惑众罪"
}, {
  "id": "425",
  "parent": "408",
  "text": "战时自伤罪"
}, {
  "id": "426",
  "parent": "408",
  "text": "逃离部队罪"
}, {
  "id": "427",
  "parent": "408",
  "text": "武器装备肇事罪"
}, {
  "id": "428",
  "parent": "408",
  "text": "擅自改变武器装备编配用途罪"
}, {
  "id": "429",
  "parent": "408",
  "text": "盗窃、抢夺武器装备、军用物资罪"
}, {
  "id": "430",
  "parent": "408",
  "text": "非法出卖、转让武器装备罪"
}, {
  "id": "431",
  "parent": "408",
  "text": "遗弃武器装备罪"
}, {
  "id": "432",
  "parent": "408",
  "text": "遗失武器装备罪"
}, {
  "id": "433",
  "parent": "408",
  "text": "擅自出卖、转让军队房地产罪"
}, {
  "id": "434",
  "parent": "408",
  "text": "虐待部属罪"
}, {
  "id": "435",
  "parent": "408",
  "text": "遗弃伤病军人罪"
}, {
  "id": "436",
  "parent": "408",
  "text": "战时拒不救治伤病军人罪"
}, {
  "id": "437",
  "parent": "408",
  "text": "战时残害居民、掠夺居民财物罪"
}, {
  "id": "438",
  "parent": "408",
  "text": "私放俘虏罪"
}, {
  "id": "439",
  "parent": "408",
  "text": "虐待俘虏罪"
}, {
  "id": "440",
  "parent": "1",
  "text": "九七年十月以前刑事案由或罪名"
}, {
  "id": "441",
  "parent": "440",
  "text": "反革命罪"
}, {
  "id": "442",
  "parent": "440",
  "text": "经济犯罪"
}, {
  "id": "443",
  "parent": "440",
  "text": "其他刑事犯罪"
}, {
  "id": "9000",
  "parent": "#",
  "text": "民事案由"
}, {
  "id": "9001",
  "parent": "9000",
  "text": "人格权纠纷"
}, {
  "id": "9002",
  "parent": "9001",
  "text": "人格权纠纷"
}, {
  "id": "9003",
  "parent": "9002",
  "text": "生命权、健康权、身体权纠纷"
}, {
  "id": "9848",
  "parent": "9003",
  "text": "生命权纠纷"
}, {
  "id": "9849",
  "parent": "9003",
  "text": "健康权纠纷"
}, {
  "id": "9850",
  "parent": "9003",
  "text": "身体权纠纷"
}, {
  "id": "9004",
  "parent": "9002",
  "text": "姓名权纠纷"
}, {
  "id": "9005",
  "parent": "9002",
  "text": "肖像权纠纷"
}, {
  "id": "9006",
  "parent": "9002",
  "text": "名誉权纠纷"
}, {
  "id": "9007",
  "parent": "9002",
  "text": "荣誉权纠纷"
}, {
  "id": "9008",
  "parent": "9002",
  "text": "隐私权纠纷"
}, {
  "id": "9009",
  "parent": "9002",
  "text": "婚姻自主权纠纷"
}, {
  "id": "9010",
  "parent": "9002",
  "text": "人身自由权纠纷"
}, {
  "id": "9011",
  "parent": "9002",
  "text": "一般人格权纠纷"
}, {
  "id": "9012",
  "parent": "9000",
  "text": "婚姻家庭、继承纠纷"
}, {
  "id": "9013",
  "parent": "9012",
  "text": "婚姻家庭纠纷"
}, {
  "id": "9014",
  "parent": "9013",
  "text": "婚约财产纠纷"
}, {
  "id": "9015",
  "parent": "9013",
  "text": "离婚纠纷"
}, {
  "id": "9016",
  "parent": "9013",
  "text": "离婚后财产纠纷"
}, {
  "id": "9017",
  "parent": "9013",
  "text": "离婚后损害责任纠纷"
}, {
  "id": "9018",
  "parent": "9013",
  "text": "婚姻无效纠纷"
}, {
  "id": "9019",
  "parent": "9013",
  "text": "撤销婚姻纠纷"
}, {
  "id": "9020",
  "parent": "9013",
  "text": "夫妻财产约定纠纷"
}, {
  "id": "9021",
  "parent": "9013",
  "text": "同居关系纠纷"
}, {
  "id": "9022",
  "parent": "9021",
  "text": "同居关系析产纠纷"
}, {
  "id": "9023",
  "parent": "9021",
  "text": "同居关系子女抚养纠纷"
}, {
  "id": "9024",
  "parent": "9013",
  "text": "抚养纠纷"
}, {
  "id": "9025",
  "parent": "9024",
  "text": "抚养费纠纷"
}, {
  "id": "9026",
  "parent": "9024",
  "text": "变更抚养关系纠纷"
}, {
  "id": "9027",
  "parent": "9013",
  "text": "扶养纠纷"
}, {
  "id": "9028",
  "parent": "9027",
  "text": "扶养费纠纷"
}, {
  "id": "9029",
  "parent": "9027",
  "text": "变更扶养关系纠纷"
}, {
  "id": "9030",
  "parent": "9013",
  "text": "赡养纠纷"
}, {
  "id": "9031",
  "parent": "9030",
  "text": "赡养费纠纷"
}, {
  "id": "9032",
  "parent": "9030",
  "text": "变更赡养关系纠纷"
}, {
  "id": "9033",
  "parent": "9013",
  "text": "收养关系纠纷"
}, {
  "id": "9034",
  "parent": "9033",
  "text": "确认收养关系纠纷"
}, {
  "id": "9035",
  "parent": "9033",
  "text": "解除收养关系纠纷"
}, {
  "id": "9036",
  "parent": "9013",
  "text": "监护权纠纷"
}, {
  "id": "9037",
  "parent": "9013",
  "text": "探望权纠纷"
}, {
  "id": "9038",
  "parent": "9013",
  "text": "分家析产纠纷"
}, {
  "id": "9039",
  "parent": "9012",
  "text": "继承纠纷"
}, {
  "id": "9040",
  "parent": "9039",
  "text": "法定继承纠纷"
}, {
  "id": "9041",
  "parent": "9040",
  "text": "转继承纠纷"
}, {
  "id": "9042",
  "parent": "9040",
  "text": "代位继承纠纷"
}, {
  "id": "9043",
  "parent": "9039",
  "text": "遗嘱继承纠纷"
}, {
  "id": "9044",
  "parent": "9039",
  "text": "被继承人债务清偿纠纷"
}, {
  "id": "9045",
  "parent": "9039",
  "text": "遗赠纠纷"
}, {
  "id": "9046",
  "parent": "9039",
  "text": "遗赠扶养协议纠纷"
}, {
  "id": "9047",
  "parent": "9000",
  "text": "物权纠纷"
}, {
  "id": "9048",
  "parent": "9047",
  "text": "不动产登记纠纷"
}, {
  "id": "9049",
  "parent": "9048",
  "text": "异议登记不当损害责任纠纷"
}, {
  "id": "9050",
  "parent": "9048",
  "text": "虚假登记损害责任纠纷"
}, {
  "id": "9051",
  "parent": "9047",
  "text": "物权保护纠纷"
}, {
  "id": "9052",
  "parent": "9051",
  "text": "物权确认纠纷"
}, {
  "id": "9053",
  "parent": "9052",
  "text": "所有权确认纠纷"
}, {
  "id": "9054",
  "parent": "9052",
  "text": "用益物权确认纠纷"
}, {
  "id": "9055",
  "parent": "9052",
  "text": "担保物权确认纠纷"
}, {
  "id": "9056",
  "parent": "9051",
  "text": "返还原物纠纷"
}, {
  "id": "9057",
  "parent": "9051",
  "text": "排除妨害纠纷"
}, {
  "id": "9058",
  "parent": "9051",
  "text": "消除危险纠纷"
}, {
  "id": "9059",
  "parent": "9051",
  "text": "修理、重作、更换纠纷"
}, {
  "id": "9060",
  "parent": "9051",
  "text": "恢复原状纠纷"
}, {
  "id": "9061",
  "parent": "9051",
  "text": "财产损害赔偿纠纷"
}, {
  "id": "9062",
  "parent": "9047",
  "text": "所有权纠纷"
}, {
  "id": "9063",
  "parent": "9062",
  "text": "侵害集体经济组织成员权益纠纷"
}, {
  "id": "9064",
  "parent": "9062",
  "text": "建筑物区分所有权纠纷"
}, {
  "id": "9065",
  "parent": "9064",
  "text": "业主专有权纠纷"
}, {
  "id": "9066",
  "parent": "9064",
  "text": "业主共有权纠纷"
}, {
  "id": "9067",
  "parent": "9064",
  "text": "车位纠纷"
}, {
  "id": "9068",
  "parent": "9064",
  "text": "车库纠纷"
}, {
  "id": "9069",
  "parent": "9062",
  "text": "业主撤销权纠纷"
}, {
  "id": "9070",
  "parent": "9062",
  "text": "业主知情权纠纷"
}, {
  "id": "9071",
  "parent": "9062",
  "text": "遗失物返还纠纷"
}, {
  "id": "9072",
  "parent": "9062",
  "text": "漂流物返还纠纷"
}, {
  "id": "9073",
  "parent": "9062",
  "text": "埋藏物返还纠纷"
}, {
  "id": "9074",
  "parent": "9062",
  "text": "隐藏物返还纠纷"
}, {
  "id": "9075",
  "parent": "9062",
  "text": "相邻关系纠纷"
}, {
  "id": "9076",
  "parent": "9075",
  "text": "相邻用水、排水纠纷"
}, {
  "id": "9077",
  "parent": "9075",
  "text": "相邻通行纠纷"
}, {
  "id": "9078",
  "parent": "9075",
  "text": "相邻土地、建筑物利用关系纠纷"
}, {
  "id": "9079",
  "parent": "9075",
  "text": "相邻通风纠纷"
}, {
  "id": "9080",
  "parent": "9075",
  "text": "相邻采光、日照纠纷"
}, {
  "id": "9081",
  "parent": "9075",
  "text": "相邻污染侵害纠纷"
}, {
  "id": "9082",
  "parent": "9075",
  "text": "相邻损害防免关系纠纷"
}, {
  "id": "9083",
  "parent": "9062",
  "text": "共有纠纷"
}, {
  "id": "9084",
  "parent": "9083",
  "text": "共有权确认纠纷"
}, {
  "id": "9085",
  "parent": "9083",
  "text": "共有物分割纠纷"
}, {
  "id": "9086",
  "parent": "9083",
  "text": "共有人优先购买权纠纷"
}, {
  "id": "9087",
  "parent": "9047",
  "text": "用益物权纠纷"
}, {
  "id": "9088",
  "parent": "9087",
  "text": "海域使用权纠纷"
}, {
  "id": "9089",
  "parent": "9087",
  "text": "探矿权纠纷"
}, {
  "id": "9090",
  "parent": "9087",
  "text": "采矿权纠纷"
}, {
  "id": "9091",
  "parent": "9087",
  "text": "取水权纠纷"
}, {
  "id": "9092",
  "parent": "9087",
  "text": "养殖权纠纷"
}, {
  "id": "9093",
  "parent": "9087",
  "text": "捕捞权纠纷"
}, {
  "id": "9094",
  "parent": "9087",
  "text": "土地承包经营权纠纷"
}, {
  "id": "9095",
  "parent": "9094",
  "text": "土地承包经营权确认纠纷"
}, {
  "id": "9096",
  "parent": "9094",
  "text": "承包地征收补偿费用分配纠纷"
}, {
  "id": "9097",
  "parent": "9094",
  "text": "土地承包经营权继承纠纷"
}, {
  "id": "9098",
  "parent": "9087",
  "text": "建设用地使用权纠纷"
}, {
  "id": "9099",
  "parent": "9087",
  "text": "宅基地使用权纠纷"
}, {
  "id": "9100",
  "parent": "9087",
  "text": "地役权纠纷"
}, {
  "id": "9101",
  "parent": "9047",
  "text": "担保物权纠纷"
}, {
  "id": "9102",
  "parent": "9101",
  "text": "抵押权纠纷"
}, {
  "id": "9103",
  "parent": "9102",
  "text": "建筑物和其他土地附着物抵押权纠纷"
}, {
  "id": "9104",
  "parent": "9102",
  "text": "在建建筑物抵押权纠纷"
}, {
  "id": "9105",
  "parent": "9102",
  "text": "建设用地使用权抵押权纠纷"
}, {
  "id": "9106",
  "parent": "9102",
  "text": "土地承包经营权抵押权纠纷"
}, {
  "id": "9107",
  "parent": "9102",
  "text": "动产抵押权纠纷"
}, {
  "id": "9108",
  "parent": "9102",
  "text": "在建船舶、航空器抵押权纠纷"
}, {
  "id": "9109",
  "parent": "9102",
  "text": "动产浮动抵押权纠纷"
}, {
  "id": "9110",
  "parent": "9102",
  "text": "最高额抵押权纠纷"
}, {
  "id": "9111",
  "parent": "9101",
  "text": "质权纠纷"
}, {
  "id": "9112",
  "parent": "9111",
  "text": "动产质权纠纷"
}, {
  "id": "9113",
  "parent": "9111",
  "text": "转质权纠纷"
}, {
  "id": "9114",
  "parent": "9111",
  "text": "最高额质权纠纷"
}, {
  "id": "9115",
  "parent": "9111",
  "text": "票据质权纠纷"
}, {
  "id": "9116",
  "parent": "9111",
  "text": "债券质权纠纷"
}, {
  "id": "9117",
  "parent": "9111",
  "text": "存单质权纠纷"
}, {
  "id": "9118",
  "parent": "9111",
  "text": "仓单质权纠纷"
}, {
  "id": "9119",
  "parent": "9111",
  "text": "提单质权纠纷"
}, {
  "id": "9120",
  "parent": "9111",
  "text": "股权质权纠纷"
}, {
  "id": "9121",
  "parent": "9111",
  "text": "基金份额质权纠纷"
}, {
  "id": "9122",
  "parent": "9111",
  "text": "知识产权质权纠纷"
}, {
  "id": "9123",
  "parent": "9111",
  "text": "应收账款质权纠纷"
}, {
  "id": "9124",
  "parent": "9101",
  "text": "留置权纠纷"
}, {
  "id": "9125",
  "parent": "9047",
  "text": "占有保护纠纷"
}, {
  "id": "9126",
  "parent": "9125",
  "text": "占有物返还纠纷"
}, {
  "id": "9127",
  "parent": "9125",
  "text": "占有排除妨害纠纷"
}, {
  "id": "9128",
  "parent": "9125",
  "text": "占有消除危险纠纷"
}, {
  "id": "9129",
  "parent": "9125",
  "text": "占有物损害赔偿纠纷"
}, {
  "id": "9130",
  "parent": "9000",
  "text": "合同、无因管理、不当得利纠纷"
}, {
  "id": "9131",
  "parent": "9130",
  "text": "合同纠纷"
}, {
  "id": "9132",
  "parent": "9131",
  "text": "缔约过失责任纠纷"
}, {
  "id": "9133",
  "parent": "9131",
  "text": "确认合同效力纠纷"
}, {
  "id": "9134",
  "parent": "9133",
  "text": "确认合同有效纠纷"
}, {
  "id": "9135",
  "parent": "9133",
  "text": "确认合同无效纠纷"
}, {
  "id": "9136",
  "parent": "9131",
  "text": "债权人代位权纠纷"
}, {
  "id": "9137",
  "parent": "9131",
  "text": "债权人撤销权纠纷"
}, {
  "id": "9138",
  "parent": "9131",
  "text": "债权转让合同纠纷"
}, {
  "id": "9139",
  "parent": "9131",
  "text": "债务转移合同纠纷"
}, {
  "id": "9140",
  "parent": "9131",
  "text": "债权债务概括转移合同纠纷"
}, {
  "id": "9141",
  "parent": "9131",
  "text": "悬赏广告纠纷"
}, {
  "id": "9142",
  "parent": "9131",
  "text": "买卖合同纠纷"
}, {
  "id": "9143",
  "parent": "9142",
  "text": "分期付款买卖合同纠纷"
}, {
  "id": "9144",
  "parent": "9142",
  "text": "凭样品买卖合同纠纷"
}, {
  "id": "9145",
  "parent": "9142",
  "text": "试用买卖合同纠纷"
}, {
  "id": "9146",
  "parent": "9142",
  "text": "互易纠纷"
}, {
  "id": "9147",
  "parent": "9142",
  "text": "国际货物买卖合同纠纷"
}, {
  "id": "9148",
  "parent": "9142",
  "text": "网络购物合同纠纷"
}, {
  "id": "9149",
  "parent": "9142",
  "text": "电视购物合同纠纷"
}, {
  "id": "9150",
  "parent": "9131",
  "text": "招标投标买卖合同纠纷"
}, {
  "id": "9151",
  "parent": "9131",
  "text": "拍卖合同纠纷"
}, {
  "id": "9152",
  "parent": "9131",
  "text": "建设用地使用权合同纠纷"
}, {
  "id": "9153",
  "parent": "9152",
  "text": "建设用地使用权出让合同纠纷"
}, {
  "id": "9154",
  "parent": "9152",
  "text": "建设用地使用权转让合同纠纷"
}, {
  "id": "9155",
  "parent": "9131",
  "text": "临时用地合同纠纷"
}, {
  "id": "9156",
  "parent": "9131",
  "text": "探矿权转让合同纠纷"
}, {
  "id": "9157",
  "parent": "9131",
  "text": "采矿权转让合同纠纷"
}, {
  "id": "9158",
  "parent": "9131",
  "text": "房地产开发经营合同纠纷"
}, {
  "id": "9159",
  "parent": "9158",
  "text": "委托代建合同纠纷"
}, {
  "id": "9160",
  "parent": "9158",
  "text": "合资、合作开发房地产合同纠纷"
}, {
  "id": "9161",
  "parent": "9158",
  "text": "项目转让合同纠纷"
}, {
  "id": "9162",
  "parent": "9131",
  "text": "房屋买卖合同纠纷"
}, {
  "id": "9163",
  "parent": "9162",
  "text": "商品房预约合同纠纷"
}, {
  "id": "9164",
  "parent": "9162",
  "text": "商品房预售合同纠纷"
}, {
  "id": "9165",
  "parent": "9162",
  "text": "商品房销售合同纠纷"
}, {
  "id": "9166",
  "parent": "9162",
  "text": "商品房委托代理销售合同纠纷"
}, {
  "id": "9167",
  "parent": "9162",
  "text": "经济适用房转让合同纠纷"
}, {
  "id": "9168",
  "parent": "9162",
  "text": "农村房屋买卖合同纠纷"
}, {
  "id": "9169",
  "parent": "9131",
  "text": "房屋拆迁安置补偿合同纠纷"
}, {
  "id": "9170",
  "parent": "9131",
  "text": "供用电合同纠纷"
}, {
  "id": "9171",
  "parent": "9131",
  "text": "供用水合同纠纷"
}, {
  "id": "9172",
  "parent": "9131",
  "text": "供用气合同纠纷"
}, {
  "id": "9173",
  "parent": "9131",
  "text": "供用热力合同纠纷"
}, {
  "id": "9174",
  "parent": "9131",
  "text": "赠与合同纠纷"
}, {
  "id": "9175",
  "parent": "9174",
  "text": "公益事业捐赠合同纠纷"
}, {
  "id": "9176",
  "parent": "9174",
  "text": "附义务赠与合同纠纷"
}, {
  "id": "9177",
  "parent": "9131",
  "text": "借款合同纠纷"
}, {
  "id": "9178",
  "parent": "9177",
  "text": "金融借款合同纠纷"
}, {
  "id": "9179",
  "parent": "9177",
  "text": "同业拆借纠纷"
}, {
  "id": "9180",
  "parent": "9177",
  "text": "企业借贷纠纷"
}, {
  "id": "9181",
  "parent": "9177",
  "text": "民间借贷纠纷"
}, {
  "id": "9182",
  "parent": "9177",
  "text": "小额借款合同纠纷"
}, {
  "id": "9183",
  "parent": "9177",
  "text": "金融不良债权转让合同纠纷"
}, {
  "id": "9184",
  "parent": "9177",
  "text": "金融不良债权追偿纠纷"
}, {
  "id": "9185",
  "parent": "9131",
  "text": "保证合同纠纷"
}, {
  "id": "9186",
  "parent": "9131",
  "text": "抵押合同纠纷"
}, {
  "id": "9187",
  "parent": "9131",
  "text": "质押合同纠纷"
}, {
  "id": "9188",
  "parent": "9131",
  "text": "定金合同纠纷"
}, {
  "id": "9189",
  "parent": "9131",
  "text": "进出口押汇纠纷"
}, {
  "id": "9190",
  "parent": "9131",
  "text": "储蓄存款合同纠纷"
}, {
  "id": "9191",
  "parent": "9131",
  "text": "银行卡纠纷"
}, {
  "id": "9192",
  "parent": "9191",
  "text": "借记卡纠纷"
}, {
  "id": "9193",
  "parent": "9191",
  "text": "信用卡纠纷"
}, {
  "id": "9194",
  "parent": "9131",
  "text": "租赁合同纠纷"
}, {
  "id": "9195",
  "parent": "9194",
  "text": "土地租赁合同纠纷"
}, {
  "id": "9196",
  "parent": "9194",
  "text": "房屋租赁合同纠纷"
}, {
  "id": "9197",
  "parent": "9194",
  "text": "车辆租赁合同纠纷"
}, {
  "id": "9198",
  "parent": "9194",
  "text": "建筑设备租赁合同纠纷"
}, {
  "id": "9199",
  "parent": "9131",
  "text": "融资租赁合同纠纷"
}, {
  "id": "9200",
  "parent": "9131",
  "text": "承揽合同纠纷"
}, {
  "id": "9201",
  "parent": "9200",
  "text": "加工合同纠纷"
}, {
  "id": "9202",
  "parent": "9200",
  "text": "定作合同纠纷"
}, {
  "id": "9203",
  "parent": "9200",
  "text": "修理合同纠纷"
}, {
  "id": "9204",
  "parent": "9200",
  "text": "复制合同纠纷"
}, {
  "id": "9205",
  "parent": "9200",
  "text": "测试合同纠纷"
}, {
  "id": "9206",
  "parent": "9200",
  "text": "检验合同纠纷"
}, {
  "id": "9207",
  "parent": "9200",
  "text": "铁路机车、车辆建造合同纠纷"
}, {
  "id": "9208",
  "parent": "9131",
  "text": "建设工程合同纠纷"
}, {
  "id": "9209",
  "parent": "9208",
  "text": "建设工程勘察合同纠纷"
}, {
  "id": "9210",
  "parent": "9208",
  "text": "建设工程设计合同纠纷"
}, {
  "id": "9211",
  "parent": "9208",
  "text": "建设工程施工合同纠纷"
}, {
  "id": "9212",
  "parent": "9208",
  "text": "建设工程价款优先受偿权纠纷"
}, {
  "id": "9213",
  "parent": "9208",
  "text": "建设工程分包合同纠纷"
}, {
  "id": "9214",
  "parent": "9208",
  "text": "建设工程监理合同纠纷"
}, {
  "id": "9215",
  "parent": "9208",
  "text": "装饰装修合同纠纷"
}, {
  "id": "9216",
  "parent": "9208",
  "text": "铁路修建合同纠纷"
}, {
  "id": "9217",
  "parent": "9208",
  "text": "农村建房施工合同纠纷"
}, {
  "id": "9218",
  "parent": "9131",
  "text": "运输合同纠纷"
}, {
  "id": "9219",
  "parent": "9218",
  "text": "公路旅客运输合同纠纷"
}, {
  "id": "9220",
  "parent": "9218",
  "text": "公路货物运输合同纠纷"
}, {
  "id": "9221",
  "parent": "9218",
  "text": "水路旅客运输合同纠纷"
}, {
  "id": "9222",
  "parent": "9218",
  "text": "水路货物运输合同纠纷"
}, {
  "id": "9223",
  "parent": "9218",
  "text": "航空旅客运输合同纠纷"
}, {
  "id": "9224",
  "parent": "9218",
  "text": "航空货物运输合同纠纷"
}, {
  "id": "9225",
  "parent": "9218",
  "text": "出租汽车运输合同纠纷"
}, {
  "id": "9226",
  "parent": "9218",
  "text": "管道运输合同纠纷"
}, {
  "id": "9227",
  "parent": "9218",
  "text": "城市公交运输合同纠纷"
}, {
  "id": "9228",
  "parent": "9218",
  "text": "联合运输合同纠纷"
}, {
  "id": "9229",
  "parent": "9218",
  "text": "多式联运合同纠纷"
}, {
  "id": "9230",
  "parent": "9218",
  "text": "铁路货物运输合同纠纷"
}, {
  "id": "9231",
  "parent": "9218",
  "text": "铁路旅客运输合同纠纷"
}, {
  "id": "9232",
  "parent": "9218",
  "text": "铁路行李运输合同纠纷"
}, {
  "id": "9233",
  "parent": "9218",
  "text": "铁路包裹运输合同纠纷"
}, {
  "id": "9234",
  "parent": "9218",
  "text": "国际铁路联运合同纠纷"
}, {
  "id": "9235",
  "parent": "9131",
  "text": "保管合同纠纷"
}, {
  "id": "9236",
  "parent": "9131",
  "text": "仓储合同纠纷"
}, {
  "id": "9237",
  "parent": "9131",
  "text": "委托合同纠纷"
}, {
  "id": "9238",
  "parent": "9237",
  "text": "进出口代理合同纠纷"
}, {
  "id": "9239",
  "parent": "9237",
  "text": "货运代理合同纠纷"
}, {
  "id": "9240",
  "parent": "9237",
  "text": "民用航空运输销售代理合同纠纷"
}, {
  "id": "9241",
  "parent": "9237",
  "text": "诉讼、仲裁、人民调解代理合同纠纷"
}, {
  "id": "9242",
  "parent": "9131",
  "text": "委托理财合同纠纷"
}, {
  "id": "9243",
  "parent": "9242",
  "text": "金融委托理财合同纠纷"
}, {
  "id": "9244",
  "parent": "9242",
  "text": "民间委托理财合同纠纷"
}, {
  "id": "9245",
  "parent": "9131",
  "text": "行纪合同纠纷"
}, {
  "id": "9246",
  "parent": "9131",
  "text": "居间合同纠纷"
}, {
  "id": "9247",
  "parent": "9131",
  "text": "补偿贸易纠纷"
}, {
  "id": "9248",
  "parent": "9131",
  "text": "借用合同纠纷"
}, {
  "id": "9249",
  "parent": "9131",
  "text": "典当纠纷"
}, {
  "id": "9250",
  "parent": "9131",
  "text": "合伙协议纠纷"
}, {
  "id": "9251",
  "parent": "9131",
  "text": "种植、养殖回收合同纠纷"
}, {
  "id": "9252",
  "parent": "9131",
  "text": "彩票、奖券纠纷"
}, {
  "id": "9253",
  "parent": "9131",
  "text": "中外合作勘探开发自然资源合同纠纷"
}, {
  "id": "9254",
  "parent": "9131",
  "text": "农业承包合同纠纷"
}, {
  "id": "9255",
  "parent": "9131",
  "text": "林业承包合同纠纷"
}, {
  "id": "9256",
  "parent": "9131",
  "text": "渔业承包合同纠纷"
}, {
  "id": "9257",
  "parent": "9131",
  "text": "牧业承包合同纠纷"
}, {
  "id": "9258",
  "parent": "9131",
  "text": "农村土地承包合同纠纷"
}, {
  "id": "9259",
  "parent": "9258",
  "text": "土地承包经营权转包合同纠纷"
}, {
  "id": "9260",
  "parent": "9258",
  "text": "土地承包经营权转让合同纠纷"
}, {
  "id": "9261",
  "parent": "9258",
  "text": "土地承包经营权互换合同纠纷"
}, {
  "id": "9262",
  "parent": "9258",
  "text": "土地承包经营权入股合同纠纷"
}, {
  "id": "9263",
  "parent": "9258",
  "text": "土地承包经营权抵押合同纠纷"
}, {
  "id": "9264",
  "parent": "9258",
  "text": "土地承包经营权出租合同纠纷"
}, {
  "id": "9265",
  "parent": "9131",
  "text": "服务合同纠纷"
}, {
  "id": "9266",
  "parent": "9265",
  "text": "电信服务合同纠纷"
}, {
  "id": "9267",
  "parent": "9265",
  "text": "邮寄服务合同纠纷"
}, {
  "id": "9268",
  "parent": "9265",
  "text": "医疗服务合同纠纷"
}, {
  "id": "9269",
  "parent": "9265",
  "text": "法律服务合同纠纷"
}, {
  "id": "9270",
  "parent": "9265",
  "text": "旅游合同纠纷"
}, {
  "id": "9271",
  "parent": "9265",
  "text": "房地产咨询合同纠纷"
}, {
  "id": "9272",
  "parent": "9265",
  "text": "房地产价格评估合同纠纷"
}, {
  "id": "9273",
  "parent": "9265",
  "text": "酒店服务合同纠纷"
}, {
  "id": "9274",
  "parent": "9265",
  "text": "财会服务合同纠纷"
}, {
  "id": "9275",
  "parent": "9265",
  "text": "餐饮服务合同纠纷"
}, {
  "id": "9276",
  "parent": "9265",
  "text": "娱乐服务合同纠纷"
}, {
  "id": "9277",
  "parent": "9265",
  "text": "有线电视服务合同纠纷"
}, {
  "id": "9278",
  "parent": "9265",
  "text": "网络服务合同纠纷"
}, {
  "id": "9279",
  "parent": "9265",
  "text": "教育培训合同纠纷"
}, {
  "id": "9280",
  "parent": "9265",
  "text": "物业服务合同纠纷"
}, {
  "id": "9281",
  "parent": "9265",
  "text": "家政服务合同纠纷"
}, {
  "id": "9282",
  "parent": "9265",
  "text": "庆典服务合同纠纷"
}, {
  "id": "9283",
  "parent": "9265",
  "text": "殡葬服务合同纠纷"
}, {
  "id": "9284",
  "parent": "9265",
  "text": "农业技术服务合同纠纷"
}, {
  "id": "9285",
  "parent": "9265",
  "text": "农机作业服务合同纠纷"
}, {
  "id": "9286",
  "parent": "9265",
  "text": "保安服务合同纠纷"
}, {
  "id": "9287",
  "parent": "9265",
  "text": "银行结算合同纠纷"
}, {
  "id": "9288",
  "parent": "9131",
  "text": "演出合同纠纷"
}, {
  "id": "9289",
  "parent": "9131",
  "text": "劳务合同纠纷"
}, {
  "id": "9290",
  "parent": "9131",
  "text": "离退休人员返聘合同纠纷"
}, {
  "id": "9291",
  "parent": "9131",
  "text": "广告合同纠纷"
}, {
  "id": "9292",
  "parent": "9131",
  "text": "展览合同纠纷"
}, {
  "id": "9293",
  "parent": "9131",
  "text": "追偿权纠纷"
}, {
  "id": "9295",
  "parent": "9130",
  "text": "不当得利纠纷"
}, {
  "id": "9296",
  "parent": "9295",
  "text": "不当得利纠纷"
}, {
  "id": "9297",
  "parent": "9130",
  "text": "无因管理纠纷"
}, {
  "id": "9298",
  "parent": "9297",
  "text": "无因管理纠纷"
}, {
  "id": "9299",
  "parent": "9000",
  "text": "知识产权与竞争纠纷"
}, {
  "id": "9300",
  "parent": "9299",
  "text": "知识产权合同纠纷"
}, {
  "id": "9301",
  "parent": "9300",
  "text": "著作权合同纠纷"
}, {
  "id": "9302",
  "parent": "9301",
  "text": "委托创作合同纠纷"
}, {
  "id": "9303",
  "parent": "9301",
  "text": "合作创作合同纠纷"
}, {
  "id": "9304",
  "parent": "9301",
  "text": "著作权转让合同纠纷"
}, {
  "id": "9305",
  "parent": "9301",
  "text": "著作权许可使用合同纠纷"
}, {
  "id": "9306",
  "parent": "9301",
  "text": "出版合同纠纷"
}, {
  "id": "9307",
  "parent": "9301",
  "text": "表演合同纠纷"
}, {
  "id": "9308",
  "parent": "9301",
  "text": "音像制品制作合同纠纷"
}, {
  "id": "9309",
  "parent": "9301",
  "text": "广播电视播放合同纠纷"
}, {
  "id": "9310",
  "parent": "9301",
  "text": "邻接权转让合同纠纷"
}, {
  "id": "9311",
  "parent": "9301",
  "text": "邻接权许可使用合同纠纷"
}, {
  "id": "9312",
  "parent": "9301",
  "text": "计算机软件开发合同纠纷"
}, {
  "id": "9313",
  "parent": "9301",
  "text": "计算机软件著作权转让合同纠纷"
}, {
  "id": "9314",
  "parent": "9301",
  "text": "计算机软件著作权许可使用合同纠纷"
}, {
  "id": "9315",
  "parent": "9300",
  "text": "商标合同纠纷"
}, {
  "id": "9316",
  "parent": "9315",
  "text": "商标权转让合同纠纷"
}, {
  "id": "9317",
  "parent": "9315",
  "text": "商标使用许可合同纠纷"
}, {
  "id": "9318",
  "parent": "9315",
  "text": "商标代理合同纠纷"
}, {
  "id": "9319",
  "parent": "9300",
  "text": "专利合同纠纷"
}, {
  "id": "9320",
  "parent": "9319",
  "text": "专利申请权转让合同纠纷"
}, {
  "id": "9321",
  "parent": "9319",
  "text": "专利权转让合同纠纷"
}, {
  "id": "9322",
  "parent": "9319",
  "text": "发明专利实施许可合同纠纷"
}, {
  "id": "9323",
  "parent": "9319",
  "text": "实用新型专利实施许可合同纠纷"
}, {
  "id": "9324",
  "parent": "9319",
  "text": "外观设计专利实施许可合同纠纷"
}, {
  "id": "9325",
  "parent": "9319",
  "text": "专利代理合同纠纷"
}, {
  "id": "9326",
  "parent": "9300",
  "text": "植物新品种合同纠纷"
}, {
  "id": "9327",
  "parent": "9326",
  "text": "植物新品种育种合同纠纷"
}, {
  "id": "9328",
  "parent": "9326",
  "text": "植物新品种申请权转让合同纠纷"
}, {
  "id": "9329",
  "parent": "9326",
  "text": "植物新品种权转让合同纠纷"
}, {
  "id": "9330",
  "parent": "9326",
  "text": "植物新品种实施许可合同纠纷"
}, {
  "id": "9331",
  "parent": "9300",
  "text": "集成电路布图设计合同纠纷"
}, {
  "id": "9332",
  "parent": "9331",
  "text": "集成电路布图设计创作合同纠纷"
}, {
  "id": "9333",
  "parent": "9331",
  "text": "集成电路布图设计专有权转让合同纠纷"
}, {
  "id": "9334",
  "parent": "9331",
  "text": "集成电路布图设计许可使用合同纠纷"
}, {
  "id": "9335",
  "parent": "9300",
  "text": "商业秘密合同纠纷"
}, {
  "id": "9336",
  "parent": "9335",
  "text": "技术秘密让与合同纠纷"
}, {
  "id": "9337",
  "parent": "9335",
  "text": "技术秘密许可使用合同纠纷"
}, {
  "id": "9338",
  "parent": "9335",
  "text": "经营秘密让与合同纠纷"
}, {
  "id": "9339",
  "parent": "9335",
  "text": "经营秘密许可使用合同纠纷"
}, {
  "id": "9340",
  "parent": "9300",
  "text": "技术合同纠纷"
}, {
  "id": "9341",
  "parent": "9340",
  "text": "技术委托开发合同纠纷"
}, {
  "id": "9342",
  "parent": "9340",
  "text": "技术合作开发合同纠纷"
}, {
  "id": "9343",
  "parent": "9340",
  "text": "技术转化合同纠纷"
}, {
  "id": "9344",
  "parent": "9340",
  "text": "技术转让合同纠纷"
}, {
  "id": "9345",
  "parent": "9340",
  "text": "技术咨询合同纠纷"
}, {
  "id": "9346",
  "parent": "9340",
  "text": "技术服务合同纠纷"
}, {
  "id": "9347",
  "parent": "9340",
  "text": "技术培训合同纠纷"
}, {
  "id": "9348",
  "parent": "9340",
  "text": "技术中介合同纠纷"
}, {
  "id": "9349",
  "parent": "9340",
  "text": "技术进口合同纠纷"
}, {
  "id": "9350",
  "parent": "9340",
  "text": "技术出口合同纠纷"
}, {
  "id": "9351",
  "parent": "9340",
  "text": "职务技术成果完成人奖励、报酬纠纷"
}, {
  "id": "9352",
  "parent": "9340",
  "text": "技术成果完成人署名权、荣誉权、奖励权纠纷"
}, {
  "id": "9353",
  "parent": "9300",
  "text": "特许经营合同纠纷"
}, {
  "id": "9354",
  "parent": "9300",
  "text": "企业名称(商号)合同纠纷"
}, {
  "id": "9355",
  "parent": "9354",
  "text": "企业名称(商号)转让合同纠纷"
}, {
  "id": "9356",
  "parent": "9354",
  "text": "企业名称(商号)使用合同纠纷"
}, {
  "id": "9357",
  "parent": "9300",
  "text": "特殊标志合同纠纷"
}, {
  "id": "9358",
  "parent": "9300",
  "text": "网络域名合同纠纷"
}, {
  "id": "9359",
  "parent": "9358",
  "text": "网络域名注册合同纠纷"
}, {
  "id": "9360",
  "parent": "9358",
  "text": "网络域名转让合同纠纷"
}, {
  "id": "9361",
  "parent": "9358",
  "text": "网络域名许可使用合同纠纷"
}, {
  "id": "9362",
  "parent": "9300",
  "text": "知识产权质押合同纠纷"
}, {
  "id": "9363",
  "parent": "9299",
  "text": "知识产权权属、侵权纠纷"
}, {
  "id": "9364",
  "parent": "9363",
  "text": "著作权权属、侵权纠纷"
}, {
  "id": "9365",
  "parent": "9364",
  "text": "著作权权属纠纷"
}, {
  "id": "9366",
  "parent": "9364",
  "text": "侵害作品发表权纠纷"
}, {
  "id": "9367",
  "parent": "9364",
  "text": "侵害作品署名权纠纷"
}, {
  "id": "9368",
  "parent": "9364",
  "text": "侵害作品修改权纠纷"
}, {
  "id": "9369",
  "parent": "9364",
  "text": "侵害保护作品完整权纠纷"
}, {
  "id": "9370",
  "parent": "9364",
  "text": "侵害作品复制权纠纷"
}, {
  "id": "9371",
  "parent": "9364",
  "text": "侵害作品发行权纠纷"
}, {
  "id": "9372",
  "parent": "9364",
  "text": "侵害作品出租权纠纷"
}, {
  "id": "9373",
  "parent": "9364",
  "text": "侵害作品展览权纠纷"
}, {
  "id": "9374",
  "parent": "9364",
  "text": "侵害作品表演权纠纷"
}, {
  "id": "9375",
  "parent": "9364",
  "text": "侵害作品放映权纠纷"
}, {
  "id": "9376",
  "parent": "9364",
  "text": "侵害作品广播权纠纷"
}, {
  "id": "9377",
  "parent": "9364",
  "text": "侵害作品信息网络传播权纠纷"
}, {
  "id": "9378",
  "parent": "9364",
  "text": "侵害作品摄制权纠纷"
}, {
  "id": "9379",
  "parent": "9364",
  "text": "侵害作品改编权纠纷"
}, {
  "id": "9380",
  "parent": "9364",
  "text": "侵害作品翻译权纠纷"
}, {
  "id": "9381",
  "parent": "9364",
  "text": "侵害作品汇编权纠纷"
}, {
  "id": "9382",
  "parent": "9364",
  "text": "侵害其他著作财产权纠纷"
}, {
  "id": "9383",
  "parent": "9364",
  "text": "出版者权权属纠纷"
}, {
  "id": "9384",
  "parent": "9364",
  "text": "表演者权权属纠纷"
}, {
  "id": "9385",
  "parent": "9364",
  "text": "录音录像制作者权权属纠纷"
}, {
  "id": "9386",
  "parent": "9364",
  "text": "广播组织权权属纠纷"
}, {
  "id": "9387",
  "parent": "9364",
  "text": "侵害出版者权纠纷"
}, {
  "id": "9388",
  "parent": "9364",
  "text": "侵害表演者权纠纷"
}, {
  "id": "9389",
  "parent": "9364",
  "text": "侵害录音录像制作者权纠纷"
}, {
  "id": "9390",
  "parent": "9364",
  "text": "侵害广播组织权纠纷"
}, {
  "id": "9391",
  "parent": "9364",
  "text": "计算机软件著作权权属纠纷"
}, {
  "id": "9392",
  "parent": "9364",
  "text": "侵害计算机软件著作权纠纷"
}, {
  "id": "9393",
  "parent": "9363",
  "text": "商标权权属、侵权纠纷"
}, {
  "id": "9394",
  "parent": "9393",
  "text": "商标权权属纠纷"
}, {
  "id": "9395",
  "parent": "9393",
  "text": "侵害商标权纠纷"
}, {
  "id": "9396",
  "parent": "9363",
  "text": "专利权权属、侵权纠纷"
}, {
  "id": "9397",
  "parent": "9396",
  "text": "专利申请权权属纠纷"
}, {
  "id": "9398",
  "parent": "9396",
  "text": "专利权权属纠纷"
}, {
  "id": "9399",
  "parent": "9396",
  "text": "侵害发明专利权纠纷"
}, {
  "id": "9400",
  "parent": "9396",
  "text": "侵害实用新型专利权纠纷"
}, {
  "id": "9401",
  "parent": "9396",
  "text": "侵害外观设计专利权纠纷"
}, {
  "id": "9402",
  "parent": "9396",
  "text": "假冒他人专利纠纷"
}, {
  "id": "9403",
  "parent": "9396",
  "text": "发明专利临时保护期使用费纠纷"
}, {
  "id": "9404",
  "parent": "9396",
  "text": "职务发明创造发明人、设计人奖励、报酬纠纷"
}, {
  "id": "9405",
  "parent": "9396",
  "text": "发明创造发明人、设计人署名权纠纷"
}, {
  "id": "9406",
  "parent": "9363",
  "text": "植物新品种权权属、侵权纠纷"
}, {
  "id": "9407",
  "parent": "9406",
  "text": "植物新品种申请权权属纠纷"
}, {
  "id": "9408",
  "parent": "9406",
  "text": "植物新品种权权属纠纷"
}, {
  "id": "9409",
  "parent": "9406",
  "text": "侵害植物新品种权纠纷"
}, {
  "id": "9410",
  "parent": "9363",
  "text": "集成电路布图设计专有权权属、侵权纠纷"
}, {
  "id": "9411",
  "parent": "9410",
  "text": "集成电路布图设计专有权权属纠纷"
}, {
  "id": "9412",
  "parent": "9410",
  "text": "侵害集成电路布图设计专有权纠纷"
}, {
  "id": "9413",
  "parent": "9363",
  "text": "侵害企业名称(商号)权纠纷"
}, {
  "id": "9414",
  "parent": "9363",
  "text": "侵害特殊标志专有权纠纷"
}, {
  "id": "9415",
  "parent": "9363",
  "text": "网络域名权属、侵权纠纷"
}, {
  "id": "9416",
  "parent": "9415",
  "text": "网络域名权属纠纷"
}, {
  "id": "9417",
  "parent": "9415",
  "text": "侵害网络域名纠纷"
}, {
  "id": "9418",
  "parent": "9363",
  "text": "发现权纠纷"
}, {
  "id": "9419",
  "parent": "9363",
  "text": "发明权纠纷"
}, {
  "id": "9420",
  "parent": "9363",
  "text": "其他科技成果权纠纷"
}, {
  "id": "9421",
  "parent": "9363",
  "text": "确认不侵害知识产权纠纷"
}, {
  "id": "9422",
  "parent": "9421",
  "text": "确认不侵害专利权纠纷"
}, {
  "id": "9423",
  "parent": "9421",
  "text": "确认不侵害商标权纠纷"
}, {
  "id": "9424",
  "parent": "9421",
  "text": "确认不侵害著作权纠纷"
}, {
  "id": "9425",
  "parent": "9363",
  "text": "因申请知识产权临时措施损害责任纠纷"
}, {
  "id": "9426",
  "parent": "9425",
  "text": "因申请诉前停止侵害专利权损害责任纠纷"
}, {
  "id": "9427",
  "parent": "9425",
  "text": "因申请诉前停止侵害注册商标专用权损害责任纠纷"
}, {
  "id": "9428",
  "parent": "9425",
  "text": "因申请诉前停止侵害著作权损害责任纠纷"
}, {
  "id": "9429",
  "parent": "9425",
  "text": "因申请诉前停止侵害植物新品种权损害责任纠纷"
}, {
  "id": "9430",
  "parent": "9425",
  "text": "因申请海关知识产权保护措施损害责任纠纷"
}, {
  "id": "9431",
  "parent": "9363",
  "text": "因恶意提起知识产权诉讼损害责任纠纷"
}, {
  "id": "9432",
  "parent": "9363",
  "text": "专利权宣告无效后返还费用纠纷"
}, {
  "id": "9433",
  "parent": "9299",
  "text": "不正当竞争纠纷"
}, {
  "id": "9434",
  "parent": "9433",
  "text": "仿冒纠纷"
}, {
  "id": "9435",
  "parent": "9434",
  "text": "擅自使用知名商品特有名称、包装、装潢纠纷"
}, {
  "id": "9436",
  "parent": "9434",
  "text": "擅自使用他人企业名称、姓名纠纷"
}, {
  "id": "9437",
  "parent": "9434",
  "text": "伪造、冒用产品质量标志纠纷"
}, {
  "id": "9438",
  "parent": "9434",
  "text": "伪造产地纠纷"
}, {
  "id": "9439",
  "parent": "9433",
  "text": "商业贿赂不正当竞争纠纷"
}, {
  "id": "9440",
  "parent": "9433",
  "text": "虚假宣传纠纷"
}, {
  "id": "9441",
  "parent": "9433",
  "text": "侵害商业秘密纠纷"
}, {
  "id": "9442",
  "parent": "9441",
  "text": "侵害技术秘密纠纷"
}, {
  "id": "9443",
  "parent": "9441",
  "text": "侵害经营秘密纠纷"
}, {
  "id": "9444",
  "parent": "9433",
  "text": "低价倾销不正当竞争纠纷"
}, {
  "id": "9445",
  "parent": "9433",
  "text": "捆绑销售不正当竞争纠纷"
}, {
  "id": "9446",
  "parent": "9433",
  "text": "有奖销售纠纷"
}, {
  "id": "9447",
  "parent": "9433",
  "text": "商业诋毁纠纷"
}, {
  "id": "9448",
  "parent": "9433",
  "text": "串通投标不正当竞争纠纷"
}, {
  "id": "9449",
  "parent": "9299",
  "text": "垄断纠纷"
}, {
  "id": "9450",
  "parent": "9449",
  "text": "垄断协议纠纷"
}, {
  "id": "9451",
  "parent": "9450",
  "text": "横向垄断协议纠纷"
}, {
  "id": "9452",
  "parent": "9450",
  "text": "纵向垄断协议纠纷"
}, {
  "id": "9453",
  "parent": "9449",
  "text": "滥用市场支配地位纠纷"
}, {
  "id": "9454",
  "parent": "9453",
  "text": "垄断定价纠纷"
}, {
  "id": "9455",
  "parent": "9453",
  "text": "掠夺定价纠纷"
}, {
  "id": "9456",
  "parent": "9453",
  "text": "拒绝交易纠纷"
}, {
  "id": "9457",
  "parent": "9453",
  "text": "限定交易纠纷"
}, {
  "id": "9458",
  "parent": "9453",
  "text": "捆绑交易纠纷"
}, {
  "id": "9459",
  "parent": "9453",
  "text": "差别待遇纠纷"
}, {
  "id": "9460",
  "parent": "9449",
  "text": "经营者集中纠纷"
}, {
  "id": "9461",
  "parent": "9000",
  "text": "劳动争议、人事争议"
}, {
  "id": "9462",
  "parent": "9461",
  "text": "劳动争议"
}, {
  "id": "9463",
  "parent": "9462",
  "text": "劳动合同纠纷"
}, {
  "id": "9464",
  "parent": "9463",
  "text": "确认劳动关系纠纷"
}, {
  "id": "9465",
  "parent": "9463",
  "text": "集体合同纠纷"
}, {
  "id": "9466",
  "parent": "9463",
  "text": "劳务派遣合同纠纷"
}, {
  "id": "9467",
  "parent": "9463",
  "text": "非全日制用工纠纷"
}, {
  "id": "9468",
  "parent": "9463",
  "text": "追索劳动报酬纠纷"
}, {
  "id": "9469",
  "parent": "9463",
  "text": "经济补偿金纠纷"
}, {
  "id": "9470",
  "parent": "9463",
  "text": "竞业限制纠纷"
}, {
  "id": "9471",
  "parent": "9462",
  "text": "社会保险纠纷"
}, {
  "id": "9472",
  "parent": "9471",
  "text": "养老保险待遇纠纷"
}, {
  "id": "9473",
  "parent": "9471",
  "text": "工伤保险待遇纠纷"
}, {
  "id": "9474",
  "parent": "9471",
  "text": "医疗保险待遇纠纷"
}, {
  "id": "9475",
  "parent": "9471",
  "text": "生育保险待遇纠纷"
}, {
  "id": "9476",
  "parent": "9471",
  "text": "失业保险待遇纠纷"
}, {
  "id": "9477",
  "parent": "9462",
  "text": "福利待遇纠纷"
}, {
  "id": "9478",
  "parent": "9461",
  "text": "人事争议"
}, {
  "id": "9479",
  "parent": "9478",
  "text": "人事争议"
}, {
  "id": "9480",
  "parent": "9479",
  "text": "辞职争议"
}, {
  "id": "9481",
  "parent": "9479",
  "text": "辞退争议"
}, {
  "id": "9482",
  "parent": "9479",
  "text": "聘用合同争议"
}, {
  "id": "9483",
  "parent": "9000",
  "text": "海事海商纠纷"
}, {
  "id": "9484",
  "parent": "9483",
  "text": "海事海商纠纷"
}, {
  "id": "9485",
  "parent": "9484",
  "text": "船舶碰撞损害责任纠纷"
}, {
  "id": "9486",
  "parent": "9484",
  "text": "船舶触碰损害责任纠纷"
}, {
  "id": "9487",
  "parent": "9484",
  "text": "船舶损坏空中设施、水下设施损害责任纠纷"
}, {
  "id": "9488",
  "parent": "9484",
  "text": "船舶污染损害责任纠纷"
}, {
  "id": "9489",
  "parent": "9484",
  "text": "海上、通海水域污染损害责任纠纷"
}, {
  "id": "9490",
  "parent": "9484",
  "text": "海上、通海水域养殖损害责任纠纷"
}, {
  "id": "9491",
  "parent": "9484",
  "text": "海上、通海水域财产损害责任纠纷"
}, {
  "id": "9492",
  "parent": "9484",
  "text": "海上、通海水域人身损害责任纠纷"
}, {
  "id": "9493",
  "parent": "9484",
  "text": "非法留置船舶、船载货物、船用燃油、船用物料损害责任纠纷"
}, {
  "id": "9494",
  "parent": "9484",
  "text": "海上、通海水域货物运输合同纠纷"
}, {
  "id": "9495",
  "parent": "9484",
  "text": "海上、通海水域旅客运输合同纠纷"
}, {
  "id": "9496",
  "parent": "9484",
  "text": "海上、通海水域行李运输合同纠纷"
}, {
  "id": "9497",
  "parent": "9484",
  "text": "船舶经营管理合同纠纷"
}, {
  "id": "9498",
  "parent": "9484",
  "text": "船舶买卖合同纠纷"
}, {
  "id": "9499",
  "parent": "9484",
  "text": "船舶建造合同纠纷"
}, {
  "id": "9500",
  "parent": "9484",
  "text": "船舶修理合同纠纷"
}, {
  "id": "9501",
  "parent": "9484",
  "text": "船舶改建合同纠纷"
}, {
  "id": "9502",
  "parent": "9484",
  "text": "船舶拆解合同纠纷"
}, {
  "id": "9503",
  "parent": "9484",
  "text": "船舶抵押合同纠纷"
}, {
  "id": "9504",
  "parent": "9484",
  "text": "航次租船合同纠纷"
}, {
  "id": "9505",
  "parent": "9484",
  "text": "船舶租用合同纠纷"
}, {
  "id": "9506",
  "parent": "9505",
  "text": "定期租船合同纠纷"
}, {
  "id": "9507",
  "parent": "9505",
  "text": "光船租赁合同纠纷"
}, {
  "id": "9508",
  "parent": "9484",
  "text": "船舶融资租赁合同纠纷"
}, {
  "id": "9509",
  "parent": "9484",
  "text": "海上、通海水域运输船舶承包合同纠纷"
}, {
  "id": "9510",
  "parent": "9484",
  "text": "渔船承包合同纠纷"
}, {
  "id": "9511",
  "parent": "9484",
  "text": "船舶属具租赁合同纠纷"
}, {
  "id": "9512",
  "parent": "9484",
  "text": "船舶属具保管合同纠纷"
}, {
  "id": "9513",
  "parent": "9484",
  "text": "海运集装箱租赁合同纠纷"
}, {
  "id": "9514",
  "parent": "9484",
  "text": "海运集装箱保管合同纠纷"
}, {
  "id": "9515",
  "parent": "9484",
  "text": "港口货物保管合同纠纷"
}, {
  "id": "9516",
  "parent": "9484",
  "text": "船舶代理合同纠纷"
}, {
  "id": "9517",
  "parent": "9484",
  "text": "海上、通海水域货运代理合同纠纷"
}, {
  "id": "9518",
  "parent": "9484",
  "text": "理货合同纠纷"
}, {
  "id": "9519",
  "parent": "9484",
  "text": "船舶物料和备品供应合同纠纷"
}, {
  "id": "9520",
  "parent": "9484",
  "text": "船员劳务合同纠纷"
}, {
  "id": "9521",
  "parent": "9484",
  "text": "海难救助合同纠纷"
}, {
  "id": "9522",
  "parent": "9484",
  "text": "海上、通海水域打捞合同纠纷"
}, {
  "id": "9523",
  "parent": "9484",
  "text": "海上、通海水域拖航合同纠纷"
}, {
  "id": "9524",
  "parent": "9484",
  "text": "海上、通海水域保险合同纠纷"
}, {
  "id": "9525",
  "parent": "9484",
  "text": "海上、通海水域保赔合同纠纷"
}, {
  "id": "9526",
  "parent": "9484",
  "text": "海上、通海水域运输联营合同纠纷"
}, {
  "id": "9527",
  "parent": "9484",
  "text": "船舶营运借款合同纠纷"
}, {
  "id": "9528",
  "parent": "9484",
  "text": "海事担保合同纠纷"
}, {
  "id": "9529",
  "parent": "9484",
  "text": "航道、港口疏浚合同纠纷"
}, {
  "id": "9530",
  "parent": "9484",
  "text": "船坞、码头建造合同纠纷"
}, {
  "id": "9531",
  "parent": "9484",
  "text": "船舶检验合同纠纷"
}, {
  "id": "9532",
  "parent": "9484",
  "text": "海事请求担保纠纷"
}, {
  "id": "9533",
  "parent": "9484",
  "text": "海上、通海水域运输重大责任事故责任纠纷"
}, {
  "id": "9534",
  "parent": "9484",
  "text": "港口作业重大责任事故责任纠纷"
}, {
  "id": "9535",
  "parent": "9484",
  "text": "港口作业纠纷"
}, {
  "id": "9536",
  "parent": "9484",
  "text": "共同海损纠纷"
}, {
  "id": "9537",
  "parent": "9484",
  "text": "海洋开发利用纠纷"
}, {
  "id": "9538",
  "parent": "9484",
  "text": "船舶共有纠纷"
}, {
  "id": "9539",
  "parent": "9484",
  "text": "船舶权属纠纷"
}, {
  "id": "9540",
  "parent": "9484",
  "text": "海运欺诈纠纷"
}, {
  "id": "9541",
  "parent": "9484",
  "text": "海事债权确权纠纷"
}, {
  "id": "9542",
  "parent": "9000",
  "text": "与公司、证券、保险、票据等有关的民事纠纷"
}, {
  "id": "9543",
  "parent": "9542",
  "text": "与企业有关的纠纷"
}, {
  "id": "9544",
  "parent": "9543",
  "text": "企业出资人权益确认纠纷"
}, {
  "id": "9545",
  "parent": "9543",
  "text": "侵害企业出资人权益纠纷"
}, {
  "id": "9546",
  "parent": "9543",
  "text": "企业公司制改造合同纠纷"
}, {
  "id": "9547",
  "parent": "9543",
  "text": "企业股份合作制改造合同纠纷"
}, {
  "id": "9548",
  "parent": "9543",
  "text": "企业债权转股权合同纠纷"
}, {
  "id": "9549",
  "parent": "9543",
  "text": "企业分立合同纠纷"
}, {
  "id": "9550",
  "parent": "9543",
  "text": "企业租赁经营合同纠纷"
}, {
  "id": "9551",
  "parent": "9543",
  "text": "企业出售合同纠纷"
}, {
  "id": "9552",
  "parent": "9543",
  "text": "挂靠经营合同纠纷"
}, {
  "id": "9553",
  "parent": "9543",
  "text": "企业兼并合同纠纷"
}, {
  "id": "9554",
  "parent": "9543",
  "text": "联营合同纠纷"
}, {
  "id": "9555",
  "parent": "9543",
  "text": "企业承包经营合同纠纷"
}, {
  "id": "9556",
  "parent": "9555",
  "text": "中外合资经营企业承包经营合同纠纷"
}, {
  "id": "9557",
  "parent": "9555",
  "text": "中外合作经营企业承包经营合同纠纷"
}, {
  "id": "9558",
  "parent": "9555",
  "text": "外商独资企业承包经营合同纠纷"
}, {
  "id": "9559",
  "parent": "9555",
  "text": "乡镇企业承包经营合同纠纷"
}, {
  "id": "9560",
  "parent": "9543",
  "text": "中外合资经营企业合同纠纷"
}, {
  "id": "9561",
  "parent": "9543",
  "text": "中外合作经营企业合同纠纷"
}, {
  "id": "9562",
  "parent": "9542",
  "text": "与公司有关的纠纷"
}, {
  "id": "9563",
  "parent": "9562",
  "text": "股东资格确认纠纷"
}, {
  "id": "9564",
  "parent": "9562",
  "text": "股东名册记载纠纷"
}, {
  "id": "9565",
  "parent": "9562",
  "text": "请求变更公司登记纠纷"
}, {
  "id": "9566",
  "parent": "9562",
  "text": "股东出资纠纷"
}, {
  "id": "9567",
  "parent": "9562",
  "text": "新增资本认购纠纷"
}, {
  "id": "9568",
  "parent": "9562",
  "text": "股东知情权纠纷"
}, {
  "id": "9569",
  "parent": "9562",
  "text": "请求公司收购股份纠纷"
}, {
  "id": "9570",
  "parent": "9562",
  "text": "股权转让纠纷"
}, {
  "id": "9571",
  "parent": "9562",
  "text": "公司决议纠纷"
}, {
  "id": "9572",
  "parent": "9571",
  "text": "公司决议效力确认纠纷"
}, {
  "id": "9573",
  "parent": "9571",
  "text": "公司决议撤销纠纷"
}, {
  "id": "9574",
  "parent": "9562",
  "text": "公司设立纠纷"
}, {
  "id": "9575",
  "parent": "9562",
  "text": "公司证照返还纠纷"
}, {
  "id": "9576",
  "parent": "9562",
  "text": "发起人责任纠纷"
}, {
  "id": "9577",
  "parent": "9562",
  "text": "公司盈余分配纠纷"
}, {
  "id": "9578",
  "parent": "9562",
  "text": "损害股东利益责任纠纷"
}, {
  "id": "9579",
  "parent": "9562",
  "text": "损害公司利益责任纠纷"
}, {
  "id": "9580",
  "parent": "9562",
  "text": "股东损害公司债权人利益责任纠纷"
}, {
  "id": "9581",
  "parent": "9562",
  "text": "公司关联交易损害责任纠纷"
}, {
  "id": "9582",
  "parent": "9562",
  "text": "公司合并纠纷"
}, {
  "id": "9583",
  "parent": "9562",
  "text": "公司分立纠纷"
}, {
  "id": "9584",
  "parent": "9562",
  "text": "公司减资纠纷"
}, {
  "id": "9585",
  "parent": "9562",
  "text": "公司增资纠纷"
}, {
  "id": "9586",
  "parent": "9562",
  "text": "公司解散纠纷"
}, {
  "id": "9587",
  "parent": "9562",
  "text": "申请公司清算"
}, {
  "id": "9588",
  "parent": "9562",
  "text": "清算责任纠纷"
}, {
  "id": "9589",
  "parent": "9562",
  "text": "上市公司收购纠纷"
}, {
  "id": "9590",
  "parent": "9542",
  "text": "合伙企业纠纷"
}, {
  "id": "9591",
  "parent": "9590",
  "text": "入伙纠纷"
}, {
  "id": "9592",
  "parent": "9590",
  "text": "退伙纠纷"
}, {
  "id": "9593",
  "parent": "9590",
  "text": "合伙企业财产份额转让纠纷"
}, {
  "id": "9594",
  "parent": "9542",
  "text": "与破产有关的纠纷"
}, {
  "id": "9595",
  "parent": "9594",
  "text": "申请破产清算"
}, {
  "id": "9596",
  "parent": "9594",
  "text": "申请破产重整"
}, {
  "id": "9597",
  "parent": "9594",
  "text": "申请破产和解"
}, {
  "id": "9598",
  "parent": "9594",
  "text": "请求撤销个别清偿行为纠纷"
}, {
  "id": "9599",
  "parent": "9594",
  "text": "请求确认债务人行为无效纠纷"
}, {
  "id": "9600",
  "parent": "9594",
  "text": "对外追收债权纠纷"
}, {
  "id": "9601",
  "parent": "9594",
  "text": "追收未缴出资纠纷"
}, {
  "id": "9602",
  "parent": "9594",
  "text": "追收抽逃出资纠纷"
}, {
  "id": "9603",
  "parent": "9594",
  "text": "追收非正常收入纠纷"
}, {
  "id": "9604",
  "parent": "9594",
  "text": "破产债权确认纠纷"
}, {
  "id": "9605",
  "parent": "9604",
  "text": "职工破产债权确认纠纷"
}, {
  "id": "9606",
  "parent": "9604",
  "text": "普通破产债权确认纠纷"
}, {
  "id": "9607",
  "parent": "9594",
  "text": "取回权纠纷"
}, {
  "id": "9608",
  "parent": "9607",
  "text": "一般取回权纠纷"
}, {
  "id": "9609",
  "parent": "9607",
  "text": "出卖人取回权纠纷"
}, {
  "id": "9610",
  "parent": "9594",
  "text": "破产抵销权纠纷"
}, {
  "id": "9611",
  "parent": "9594",
  "text": "别除权纠纷"
}, {
  "id": "9612",
  "parent": "9594",
  "text": "破产撤销权纠纷"
}, {
  "id": "9613",
  "parent": "9594",
  "text": "损害债务人利益赔偿纠纷"
}, {
  "id": "9614",
  "parent": "9594",
  "text": "管理人责任纠纷"
}, {
  "id": "9615",
  "parent": "9542",
  "text": "证券纠纷"
}, {
  "id": "9616",
  "parent": "9615",
  "text": "证券权利确认纠纷"
}, {
  "id": "9617",
  "parent": "9616",
  "text": "股票权利确认纠纷"
}, {
  "id": "9618",
  "parent": "9616",
  "text": "公司债券权利确认纠纷"
}, {
  "id": "9619",
  "parent": "9616",
  "text": "国债权利确认纠纷"
}, {
  "id": "9620",
  "parent": "9616",
  "text": "证券投资基金权利确认纠纷"
}, {
  "id": "9621",
  "parent": "9615",
  "text": "证券交易合同纠纷"
}, {
  "id": "9622",
  "parent": "9621",
  "text": "股票交易纠纷"
}, {
  "id": "9623",
  "parent": "9621",
  "text": "公司债券交易纠纷"
}, {
  "id": "9624",
  "parent": "9621",
  "text": "国债交易纠纷"
}, {
  "id": "9625",
  "parent": "9621",
  "text": "证券投资基金交易纠纷"
}, {
  "id": "9626",
  "parent": "9615",
  "text": "金融衍生品种交易纠纷"
}, {
  "id": "9627",
  "parent": "9615",
  "text": "证券承销合同纠纷"
}, {
  "id": "9628",
  "parent": "9627",
  "text": "证券代销合同纠纷"
}, {
  "id": "9629",
  "parent": "9627",
  "text": "证券包销合同纠纷"
}, {
  "id": "9630",
  "parent": "9615",
  "text": "证券投资咨询纠纷"
}, {
  "id": "9631",
  "parent": "9615",
  "text": "证券资信评级服务合同纠纷"
}, {
  "id": "9632",
  "parent": "9615",
  "text": "证券回购合同纠纷"
}, {
  "id": "9633",
  "parent": "9632",
  "text": "股票回购合同纠纷"
}, {
  "id": "9634",
  "parent": "9632",
  "text": "国债回购合同纠纷"
}, {
  "id": "9635",
  "parent": "9632",
  "text": "公司债券回购合同纠纷"
}, {
  "id": "9636",
  "parent": "9632",
  "text": "证券投资基金回购合同纠纷"
}, {
  "id": "9637",
  "parent": "9632",
  "text": "质押式证券回购纠纷"
}, {
  "id": "9638",
  "parent": "9615",
  "text": "证券上市合同纠纷"
}, {
  "id": "9639",
  "parent": "9615",
  "text": "证券交易代理合同纠纷"
}, {
  "id": "9640",
  "parent": "9615",
  "text": "证券上市保荐合同纠纷"
}, {
  "id": "9641",
  "parent": "9615",
  "text": "证券发行纠纷"
}, {
  "id": "9642",
  "parent": "9641",
  "text": "证券认购纠纷"
}, {
  "id": "9643",
  "parent": "9641",
  "text": "证券发行失败纠纷"
}, {
  "id": "9644",
  "parent": "9615",
  "text": "证券返还纠纷"
}, {
  "id": "9645",
  "parent": "9615",
  "text": "证券欺诈责任纠纷"
}, {
  "id": "9646",
  "parent": "9645",
  "text": "证券内幕交易责任纠纷"
}, {
  "id": "9647",
  "parent": "9645",
  "text": "操纵证券交易市场责任纠纷"
}, {
  "id": "9648",
  "parent": "9645",
  "text": "证券虚假陈述责任纠纷"
}, {
  "id": "9649",
  "parent": "9645",
  "text": "欺诈客户责任纠纷"
}, {
  "id": "9650",
  "parent": "9615",
  "text": "证券托管纠纷"
}, {
  "id": "9651",
  "parent": "9615",
  "text": "证券登记、存管、结算纠纷"
}, {
  "id": "9652",
  "parent": "9615",
  "text": "融资融券交易纠纷"
}, {
  "id": "9653",
  "parent": "9615",
  "text": "客户交易结算资金纠纷"
}, {
  "id": "9654",
  "parent": "9542",
  "text": "期货交易纠纷"
}, {
  "id": "9655",
  "parent": "9654",
  "text": "期货经纪合同纠纷"
}, {
  "id": "9656",
  "parent": "9654",
  "text": "期货透支交易纠纷"
}, {
  "id": "9657",
  "parent": "9654",
  "text": "期货强行平仓纠纷"
}, {
  "id": "9658",
  "parent": "9654",
  "text": "期货实物交割纠纷"
}, {
  "id": "9659",
  "parent": "9654",
  "text": "期货保证合约纠纷"
}, {
  "id": "9660",
  "parent": "9654",
  "text": "期货交易代理合同纠纷"
}, {
  "id": "9661",
  "parent": "9654",
  "text": "侵占期货交易保证金纠纷"
}, {
  "id": "9662",
  "parent": "9654",
  "text": "期货欺诈责任纠纷"
}, {
  "id": "9663",
  "parent": "9654",
  "text": "操纵期货交易市场责任纠纷"
}, {
  "id": "9664",
  "parent": "9654",
  "text": "期货内幕交易责任纠纷"
}, {
  "id": "9665",
  "parent": "9654",
  "text": "期货虚假信息责任纠纷"
}, {
  "id": "9666",
  "parent": "9542",
  "text": "信托纠纷"
}, {
  "id": "9667",
  "parent": "9666",
  "text": "民事信托纠纷"
}, {
  "id": "9668",
  "parent": "9666",
  "text": "营业信托纠纷"
}, {
  "id": "9669",
  "parent": "9666",
  "text": "公益信托纠纷"
}, {
  "id": "9670",
  "parent": "9542",
  "text": "保险纠纷"
}, {
  "id": "9671",
  "parent": "9670",
  "text": "财产保险合同纠纷"
}, {
  "id": "9672",
  "parent": "9671",
  "text": "财产损失保险合同纠纷"
}, {
  "id": "9673",
  "parent": "9671",
  "text": "责任保险合同纠纷"
}, {
  "id": "9674",
  "parent": "9671",
  "text": "信用保险合同纠纷"
}, {
  "id": "9675",
  "parent": "9671",
  "text": "保证保险合同纠纷"
}, {
  "id": "9676",
  "parent": "9671",
  "text": "保险人代位求偿权纠纷"
}, {
  "id": "9677",
  "parent": "9670",
  "text": "人身保险合同纠纷"
}, {
  "id": "9678",
  "parent": "9677",
  "text": "人寿保险合同纠纷"
}, {
  "id": "9679",
  "parent": "9677",
  "text": "意外伤害保险合同纠纷"
}, {
  "id": "9680",
  "parent": "9677",
  "text": "健康保险合同纠纷"
}, {
  "id": "9681",
  "parent": "9670",
  "text": "再保险合同纠纷"
}, {
  "id": "9682",
  "parent": "9670",
  "text": "保险经纪合同纠纷"
}, {
  "id": "9683",
  "parent": "9670",
  "text": "保险代理合同纠纷"
}, {
  "id": "9684",
  "parent": "9670",
  "text": "进出口信用保险合同纠纷"
}, {
  "id": "9685",
  "parent": "9670",
  "text": "保险费纠纷"
}, {
  "id": "9686",
  "parent": "9542",
  "text": "票据纠纷"
}, {
  "id": "9687",
  "parent": "9686",
  "text": "票据付款请求权纠纷"
}, {
  "id": "9688",
  "parent": "9686",
  "text": "票据追索权纠纷"
}, {
  "id": "9689",
  "parent": "9686",
  "text": "票据交付请求权纠纷"
}, {
  "id": "9690",
  "parent": "9686",
  "text": "票据返还请求权纠纷"
}, {
  "id": "9691",
  "parent": "9686",
  "text": "票据损害责任纠纷"
}, {
  "id": "9692",
  "parent": "9686",
  "text": "票据利益返还请求权纠纷"
}, {
  "id": "9693",
  "parent": "9686",
  "text": "汇票回单签发请求权纠纷"
}, {
  "id": "9694",
  "parent": "9686",
  "text": "票据保证纠纷"
}, {
  "id": "9695",
  "parent": "9686",
  "text": "确认票据无效纠纷"
}, {
  "id": "9696",
  "parent": "9686",
  "text": "票据代理纠纷"
}, {
  "id": "9697",
  "parent": "9686",
  "text": "票据回购纠纷"
}, {
  "id": "9698",
  "parent": "9542",
  "text": "信用证纠纷"
}, {
  "id": "9699",
  "parent": "9698",
  "text": "委托开立信用证纠纷"
}, {
  "id": "9700",
  "parent": "9698",
  "text": "信用证开证纠纷"
}, {
  "id": "9701",
  "parent": "9698",
  "text": "信用证议付纠纷"
}, {
  "id": "9702",
  "parent": "9698",
  "text": "信用证欺诈纠纷"
}, {
  "id": "9703",
  "parent": "9698",
  "text": "信用证融资纠纷"
}, {
  "id": "9704",
  "parent": "9698",
  "text": "信用证转让纠纷"
}, {
  "id": "9705",
  "parent": "9000",
  "text": "侵权责任纠纷"
}, {
  "id": "9706",
  "parent": "9705",
  "text": "侵权责任纠纷"
}, {
  "id": "9707",
  "parent": "9706",
  "text": "监护人责任纠纷"
}, {
  "id": "9708",
  "parent": "9706",
  "text": "用人单位责任纠纷"
}, {
  "id": "9709",
  "parent": "9706",
  "text": "劳务派遣工作人员侵权责任纠纷"
}, {
  "id": "9710",
  "parent": "9706",
  "text": "提供劳务者致害责任纠纷"
}, {
  "id": "9711",
  "parent": "9706",
  "text": "提供劳务者受害责任纠纷"
}, {
  "id": "9712",
  "parent": "9706",
  "text": "网络侵权责任纠纷"
}, {
  "id": "9713",
  "parent": "9706",
  "text": "违反安全保障义务责任纠纷"
}, {
  "id": "9714",
  "parent": "9713",
  "text": "公共场所管理人责任纠纷"
}, {
  "id": "9715",
  "parent": "9713",
  "text": "群众性活动组织者责任纠纷"
}, {
  "id": "9716",
  "parent": "9706",
  "text": "教育机构责任纠纷"
}, {
  "id": "9717",
  "parent": "9706",
  "text": "产品责任纠纷"
}, {
  "id": "9718",
  "parent": "9717",
  "text": "产品生产者责任纠纷"
}, {
  "id": "9719",
  "parent": "9717",
  "text": "产品销售者责任纠纷"
}, {
  "id": "9720",
  "parent": "9717",
  "text": "产品运输者责任纠纷"
}, {
  "id": "9721",
  "parent": "9717",
  "text": "产品仓储者责任纠纷"
}, {
  "id": "9722",
  "parent": "9706",
  "text": "机动车交通事故责任纠纷"
}, {
  "id": "9723",
  "parent": "9706",
  "text": "医疗损害责任纠纷"
}, {
  "id": "9724",
  "parent": "9723",
  "text": "侵害患者知情同意权责任纠纷"
}, {
  "id": "9725",
  "parent": "9723",
  "text": "医疗产品责任纠纷"
}, {
  "id": "9726",
  "parent": "9706",
  "text": "环境污染责任纠纷"
}, {
  "id": "9727",
  "parent": "9726",
  "text": "大气污染责任纠纷"
}, {
  "id": "9728",
  "parent": "9726",
  "text": "水污染责任纠纷"
}, {
  "id": "9729",
  "parent": "9726",
  "text": "噪声污染责任纠纷"
}, {
  "id": "9730",
  "parent": "9726",
  "text": "放射性污染责任纠纷"
}, {
  "id": "9731",
  "parent": "9726",
  "text": "土壤污染责任纠纷"
}, {
  "id": "9732",
  "parent": "9726",
  "text": "电子废物污染责任纠纷"
}, {
  "id": "9733",
  "parent": "9726",
  "text": "固体废物污染责任纠纷"
}, {
  "id": "9734",
  "parent": "9706",
  "text": "高度危险责任纠纷"
}, {
  "id": "9735",
  "parent": "9734",
  "text": "民用核设施损害责任纠纷"
}, {
  "id": "9736",
  "parent": "9734",
  "text": "民用航空器损害责任纠纷"
}, {
  "id": "9737",
  "parent": "9734",
  "text": "占有、使用高度危险物损害责任纠纷"
}, {
  "id": "9738",
  "parent": "9734",
  "text": "高度危险活动损害责任纠纷"
}, {
  "id": "9739",
  "parent": "9734",
  "text": "遗失、抛弃高度危险物损害责任纠纷"
}, {
  "id": "9740",
  "parent": "9734",
  "text": "非法占有高度危险物损害责任纠纷"
}, {
  "id": "9741",
  "parent": "9706",
  "text": "饲养动物损害责任纠纷"
}, {
  "id": "9742",
  "parent": "9706",
  "text": "物件损害责任纠纷"
}, {
  "id": "9743",
  "parent": "9742",
  "text": "物件脱落、坠落损害责任纠纷"
}, {
  "id": "9744",
  "parent": "9742",
  "text": "建筑物、构筑物倒塌损害责任纠纷"
}, {
  "id": "9745",
  "parent": "9742",
  "text": "不明抛掷物、坠落物损害责任纠纷"
}, {
  "id": "9746",
  "parent": "9742",
  "text": "堆放物倒塌致害责任纠纷"
}, {
  "id": "9747",
  "parent": "9742",
  "text": "公共道路妨碍通行损害责任纠纷"
}, {
  "id": "9748",
  "parent": "9742",
  "text": "林木折断损害责任纠纷"
}, {
  "id": "9749",
  "parent": "9742",
  "text": "地面施工、地下设施损害责任纠纷"
}, {
  "id": "9750",
  "parent": "9706",
  "text": "触电人身损害责任纠纷"
}, {
  "id": "9751",
  "parent": "9706",
  "text": "义务帮工人受害责任纠纷"
}, {
  "id": "9752",
  "parent": "9706",
  "text": "见义勇为人受害责任纠纷"
}, {
  "id": "9753",
  "parent": "9706",
  "text": "公证损害责任纠纷"
}, {
  "id": "9754",
  "parent": "9706",
  "text": "防卫过当损害责任纠纷"
}, {
  "id": "9755",
  "parent": "9706",
  "text": "紧急避险损害责任纠纷"
}, {
  "id": "9756",
  "parent": "9706",
  "text": "驻香港、澳门特别行政区军人执行职务侵权责任纠纷"
}, {
  "id": "9757",
  "parent": "9706",
  "text": "铁路运输损害责任纠纷"
}, {
  "id": "9758",
  "parent": "9757",
  "text": "铁路运输人身损害责任纠纷"
}, {
  "id": "9759",
  "parent": "9757",
  "text": "铁路运输财产损害责任纠纷"
}, {
  "id": "9760",
  "parent": "9706",
  "text": "水上运输损害责任纠纷"
}, {
  "id": "9761",
  "parent": "9760",
  "text": "水上运输人身损害责任纠纷"
}, {
  "id": "9762",
  "parent": "9760",
  "text": "水上运输财产损害责任纠纷"
}, {
  "id": "9763",
  "parent": "9706",
  "text": "航空运输损害责任纠纷"
}, {
  "id": "9764",
  "parent": "9763",
  "text": "航空运输人身损害责任纠纷"
}, {
  "id": "9765",
  "parent": "9763",
  "text": "航空运输财产损害责任纠纷"
}, {
  "id": "9766",
  "parent": "9706",
  "text": "因申请诉前财产保全损害责任纠纷"
}, {
  "id": "9767",
  "parent": "9706",
  "text": "因申请诉前证据保全损害责任纠纷"
}, {
  "id": "9768",
  "parent": "9706",
  "text": "因申请诉中财产保全损害责任纠纷"
}, {
  "id": "9769",
  "parent": "9706",
  "text": "因申请诉中证据保全损害责任纠纷"
}, {
  "id": "9770",
  "parent": "9706",
  "text": "因申请先予执行损害责任纠纷"
}, {
  "id": "9771",
  "parent": "9000",
  "text": "适用特殊程序案件案由"
}, {
  "id": "9772",
  "parent": "9771",
  "text": "选民资格案件"
}, {
  "id": "9773",
  "parent": "9772",
  "text": "申请确定选民资格"
}, {
  "id": "9774",
  "parent": "9771",
  "text": "宣告失踪、宣告死亡案件"
}, {
  "id": "9775",
  "parent": "9774",
  "text": "申请宣告公民失踪"
}, {
  "id": "9776",
  "parent": "9774",
  "text": "申请撤销宣告失踪"
}, {
  "id": "9777",
  "parent": "9774",
  "text": "申请为失踪人财产指定、变更代管人"
}, {
  "id": "9778",
  "parent": "9774",
  "text": "失踪人债务支付纠纷"
}, {
  "id": "9779",
  "parent": "9774",
  "text": "申请宣告公民死亡"
}, {
  "id": "9780",
  "parent": "9774",
  "text": "申请撤销宣告公民死亡"
}, {
  "id": "9781",
  "parent": "9774",
  "text": "被撤销死亡宣告人请求返还财产纠纷"
}, {
  "id": "9782",
  "parent": "9771",
  "text": "认定公民无民事行为能力、限制民事行为能力案件"
}, {
  "id": "9783",
  "parent": "9782",
  "text": "申请宣告公民无民事行为能力"
}, {
  "id": "9784",
  "parent": "9782",
  "text": "申请宣告公民限制民事行为能力"
}, {
  "id": "9785",
  "parent": "9782",
  "text": "申请宣告公民恢复限制民事行为能力"
}, {
  "id": "9786",
  "parent": "9782",
  "text": "申请宣告公民恢复完全民事行为能力"
}, {
  "id": "9787",
  "parent": "9771",
  "text": "认定财产无主案件"
}, {
  "id": "9788",
  "parent": "9787",
  "text": "申请认定财产无主"
}, {
  "id": "9789",
  "parent": "9787",
  "text": "申请撤销认定财产无主"
}, {
  "id": "9790",
  "parent": "9771",
  "text": "监护权特别程序案件"
}, {
  "id": "9791",
  "parent": "9790",
  "text": "申请确定监护人"
}, {
  "id": "9792",
  "parent": "9790",
  "text": "申请变更监护人"
}, {
  "id": "9793",
  "parent": "9790",
  "text": "申请撤销监护人资格"
}, {
  "id": "9794",
  "parent": "9771",
  "text": "督促程序案件"
}, {
  "id": "9795",
  "parent": "9794",
  "text": "申请支付令"
}, {
  "id": "9847",
  "parent": "9794",
  "text": "撤销支付令"
}, {
  "id": "9796",
  "parent": "9771",
  "text": "公示催告程序案件"
}, {
  "id": "9797",
  "parent": "9796",
  "text": "申请公示催告"
}, {
  "id": "9798",
  "parent": "9771",
  "text": "申请诉前停止侵害知识产权案件"
}, {
  "id": "9799",
  "parent": "9798",
  "text": "申请诉前停止侵害专利权"
}, {
  "id": "9800",
  "parent": "9798",
  "text": "申请诉前停止侵害注册商标专用权"
}, {
  "id": "9801",
  "parent": "9798",
  "text": "申请诉前停止侵害著作权"
}, {
  "id": "9802",
  "parent": "9798",
  "text": "申请诉前停止侵害植物新品种权"
}, {
  "id": "9803",
  "parent": "9771",
  "text": "申请保全案件"
}, {
  "id": "9804",
  "parent": "9803",
  "text": "申请诉前财产保全"
}, {
  "id": "9805",
  "parent": "9803",
  "text": "申请诉中财产保全"
}, {
  "id": "9806",
  "parent": "9803",
  "text": "申请诉前证据保全"
}, {
  "id": "9807",
  "parent": "9803",
  "text": "申请诉中证据保全"
}, {
  "id": "9808",
  "parent": "9803",
  "text": "仲裁程序中的财产保全"
}, {
  "id": "9809",
  "parent": "9803",
  "text": "仲裁程序中的证据保全"
}, {
  "id": "9810",
  "parent": "9803",
  "text": "申请中止支付信用证项下款项"
}, {
  "id": "9811",
  "parent": "9803",
  "text": "申请中止支付保函项下款项"
}, {
  "id": "9812",
  "parent": "9771",
  "text": "仲裁程序案件"
}, {
  "id": "9813",
  "parent": "9812",
  "text": "申请确认仲裁协议效力"
}, {
  "id": "9814",
  "parent": "9812",
  "text": "申请撤销仲裁裁决"
}, {
  "id": "9815",
  "parent": "9771",
  "text": "海事诉讼特别程序案件"
}, {
  "id": "9816",
  "parent": "9815",
  "text": "申请海事请求保全"
}, {
  "id": "9817",
  "parent": "9816",
  "text": "申请扣押船舶"
}, {
  "id": "9818",
  "parent": "9816",
  "text": "申请拍卖扣押船舶"
}, {
  "id": "9819",
  "parent": "9816",
  "text": "申请扣押船载货物"
}, {
  "id": "9820",
  "parent": "9816",
  "text": "申请拍卖扣押船载货物"
}, {
  "id": "9821",
  "parent": "9816",
  "text": "申请扣押船用燃油及船用物料"
}, {
  "id": "9822",
  "parent": "9816",
  "text": "申请拍卖扣押船用燃油及船用物料"
}, {
  "id": "9823",
  "parent": "9815",
  "text": "申请海事支付令"
}, {
  "id": "9824",
  "parent": "9815",
  "text": "申请海事强制令"
}, {
  "id": "9825",
  "parent": "9815",
  "text": "申请海事证据保全"
}, {
  "id": "9826",
  "parent": "9815",
  "text": "申请设立海事赔偿责任限制基金"
}, {
  "id": "9827",
  "parent": "9815",
  "text": "申请船舶优先权催告"
}, {
  "id": "9828",
  "parent": "9815",
  "text": "申请海事债权登记与受偿"
}, {
  "id": "9294",
  "parent": "9771",
  "text": "请求确认人民调解协议效力"
}, {
  "id": "9845",
  "parent": "9294",
  "text": "申请确认人民调解协议效力"
}, {
  "id": "9846",
  "parent": "9294",
  "text": "申请撤销调解确认决定"
}, {
  "id": "9860",
  "parent": "9771",
  "text": "申请实现担保物权案件"
}, {
  "id": "9841",
  "parent": "9771",
  "text": "执行异议之诉"
}, {
  "id": "9842",
  "parent": "9841",
  "text": "案外人执行异议之诉"
}, {
  "id": "9843",
  "parent": "9841",
  "text": "申请执行人执行异议之诉"
}, {
  "id": "9844",
  "parent": "9841",
  "text": "执行分配方案异议之诉"
}, {
  "id": "9829",
  "parent": "9771",
  "text": "申请承认与执行法院判决、仲裁裁决案件"
}, {
  "id": "9830",
  "parent": "9829",
  "text": "申请执行海事仲裁裁决"
}, {
  "id": "9831",
  "parent": "9829",
  "text": "申请执行知识产权仲裁裁决"
}, {
  "id": "9832",
  "parent": "9829",
  "text": "申请执行涉外仲裁裁决"
}, {
  "id": "9833",
  "parent": "9829",
  "text": "申请认可和执行香港特别行政区法院民事判决"
}, {
  "id": "9834",
  "parent": "9829",
  "text": "申请认可和执行香港特别行政区仲裁裁决"
}, {
  "id": "9835",
  "parent": "9829",
  "text": "申请认可和执行澳门特别行政区法院民事判决"
}, {
  "id": "9836",
  "parent": "9829",
  "text": "申请认可和执行澳门特别行政区仲裁裁决"
}, {
  "id": "9837",
  "parent": "9829",
  "text": "申请认可和执行台湾地区法院民事判决"
}, {
  "id": "9838",
  "parent": "9829",
  "text": "申请认可和执行台湾地区仲裁裁决"
}, {
  "id": "9839",
  "parent": "9829",
  "text": "申请承认和执行外国法院民事判决、裁定"
}, {
  "id": "9840",
  "parent": "9829",
  "text": "申请承认和执行外国仲裁裁决"
}, {
  "id": "9851",
  "parent": "9771",
  "text": "协助送达司法文书和调查取证"
}, {
  "id": "9852",
  "parent": "9851",
  "text": "协助香港特别行政区送达司法文书"
}, {
  "id": "9853",
  "parent": "9851",
  "text": "协助香港特别行政区调查取证"
}, {
  "id": "9854",
  "parent": "9851",
  "text": "协助澳门特别行政区送达司法文书"
}, {
  "id": "9855",
  "parent": "9851",
  "text": "协助澳门特别行政区调查取证"
}, {
  "id": "9856",
  "parent": "9851",
  "text": "协助台湾地区送达司法文书"
}, {
  "id": "9857",
  "parent": "9851",
  "text": "协助台湾地区调查取证"
}, {
  "id": "9858",
  "parent": "9851",
  "text": "协助外国送达司法文书"
}, {
  "id": "9859",
  "parent": "9851",
  "text": "协助外国调查取证"
}, {
  "id": "3200",
  "parent": "#",
  "text": "执行案由"
}, {
  "id": "3201",
  "parent": "3200",
  "text": "刑事"
}, {
  "id": "3202",
  "parent": "3201",
  "text": "财产刑"
}, {
  "id": "3203",
  "parent": "3202",
  "text": "罚金"
}, {
  "id": "3204",
  "parent": "3202",
  "text": "没收财产"
}, {
  "id": "3205",
  "parent": "3201",
  "text": "附带民事赔偿"
}, {
  "id": "3234",
  "parent": "3201",
  "text": "责令退赔"
}, {
  "id": "3235",
  "parent": "3201",
  "text": "追缴违法所得"
}, {
  "id": "3206",
  "parent": "3200",
  "text": "民事"
}, {
  "id": "3207",
  "parent": "3206",
  "text": "人格权"
}, {
  "id": "3208",
  "parent": "3206",
  "text": "婚姻家庭、继承"
}, {
  "id": "3236",
  "parent": "3208",
  "text": "婚姻家庭纠纷"
}, {
  "id": "3237",
  "parent": "3208",
  "text": "继承纠纷"
}, {
  "id": "3209",
  "parent": "3206",
  "text": "物权"
}, {
  "id": "3238",
  "parent": "3209",
  "text": "不动产登记纠纷"
}, {
  "id": "3239",
  "parent": "3209",
  "text": "物权保护纠纷"
}, {
  "id": "3240",
  "parent": "3209",
  "text": "所有权纠纷"
}, {
  "id": "3241",
  "parent": "3209",
  "text": "用益物权纠纷"
}, {
  "id": "3242",
  "parent": "3209",
  "text": "担保物权纠纷"
}, {
  "id": "3210",
  "parent": "3206",
  "text": "合同、无因管理、不当得利"
}, {
  "id": "3245",
  "parent": "3210",
  "text": "合同纠纷"
}, {
  "id": "3246",
  "parent": "3245",
  "text": "缔约过失责任纠纷"
}, {
  "id": "3247",
  "parent": "3245",
  "text": "确认合同效力纠纷"
}, {
  "id": "3248",
  "parent": "3245",
  "text": "债权人代位权纠纷"
}, {
  "id": "3249",
  "parent": "3245",
  "text": "债权人撤销权纠纷"
}, {
  "id": "3250",
  "parent": "3245",
  "text": "债权转让合同纠纷"
}, {
  "id": "3251",
  "parent": "3245",
  "text": "债务转移合同纠纷"
}, {
  "id": "3252",
  "parent": "3245",
  "text": "债权债务概括转移合同纠纷"
}, {
  "id": "3253",
  "parent": "3245",
  "text": "悬赏广告纠纷"
}, {
  "id": "3254",
  "parent": "3245",
  "text": "买卖合同纠纷"
}, {
  "id": "3255",
  "parent": "3245",
  "text": "招标投标买卖合同纠纷"
}, {
  "id": "3256",
  "parent": "3245",
  "text": "拍卖合同纠纷"
}, {
  "id": "3257",
  "parent": "3245",
  "text": "建设用地使用权合同纠纷"
}, {
  "id": "3258",
  "parent": "3245",
  "text": "临时用地合同纠纷"
}, {
  "id": "3259",
  "parent": "3245",
  "text": "探矿权转让合同纠纷"
}, {
  "id": "3260",
  "parent": "3245",
  "text": "采矿权转让合同纠纷"
}, {
  "id": "3261",
  "parent": "3245",
  "text": "房地产开发经营合同纠纷"
}, {
  "id": "3262",
  "parent": "3245",
  "text": "房屋买卖合同纠纷"
}, {
  "id": "3263",
  "parent": "3245",
  "text": "房屋拆迁安置补偿合同纠纷"
}, {
  "id": "3264",
  "parent": "3245",
  "text": "供用电合同纠纷"
}, {
  "id": "3265",
  "parent": "3245",
  "text": "供用水合同纠纷"
}, {
  "id": "3266",
  "parent": "3245",
  "text": "供用气合同纠纷"
}, {
  "id": "3267",
  "parent": "3245",
  "text": "供用热力合同纠纷"
}, {
  "id": "3268",
  "parent": "3245",
  "text": "赠与合同纠纷"
}, {
  "id": "3269",
  "parent": "3245",
  "text": "借款合同纠纷"
}, {
  "id": "3270",
  "parent": "3245",
  "text": "保证合同纠纷"
}, {
  "id": "3271",
  "parent": "3245",
  "text": "抵押合同纠纷"
}, {
  "id": "3272",
  "parent": "3245",
  "text": "质押合同纠纷"
}, {
  "id": "3273",
  "parent": "3245",
  "text": "定金合同纠纷"
}, {
  "id": "3274",
  "parent": "3245",
  "text": "进出口押汇纠纷"
}, {
  "id": "3275",
  "parent": "3245",
  "text": "储蓄存款合同纠纷"
}, {
  "id": "3276",
  "parent": "3245",
  "text": "银行卡纠纷"
}, {
  "id": "3277",
  "parent": "3245",
  "text": "租赁合同纠纷"
}, {
  "id": "3278",
  "parent": "3245",
  "text": "融资租赁合同纠纷"
}, {
  "id": "3279",
  "parent": "3245",
  "text": "承揽合同纠纷"
}, {
  "id": "3280",
  "parent": "3245",
  "text": "建设工程合同纠纷"
}, {
  "id": "3281",
  "parent": "3245",
  "text": "运输合同纠纷"
}, {
  "id": "3282",
  "parent": "3245",
  "text": "保管合同纠纷"
}, {
  "id": "3283",
  "parent": "3245",
  "text": "仓储合同纠纷"
}, {
  "id": "3284",
  "parent": "3245",
  "text": "委托合同纠纷"
}, {
  "id": "3285",
  "parent": "3245",
  "text": "委托理财合同纠纷"
}, {
  "id": "3286",
  "parent": "3245",
  "text": "行纪合同纠纷"
}, {
  "id": "3287",
  "parent": "3245",
  "text": "居间合同纠纷"
}, {
  "id": "3288",
  "parent": "3245",
  "text": "补偿贸易纠纷"
}, {
  "id": "3289",
  "parent": "3245",
  "text": "借用合同纠纷"
}, {
  "id": "3290",
  "parent": "3245",
  "text": "典当纠纷"
}, {
  "id": "3291",
  "parent": "3245",
  "text": "合伙协议纠纷"
}, {
  "id": "3292",
  "parent": "3245",
  "text": "种植、养殖回收合同纠纷"
}, {
  "id": "3293",
  "parent": "3245",
  "text": "彩票、奖券纠纷"
}, {
  "id": "3294",
  "parent": "3245",
  "text": "中外合作勘探开发自然资源合同纠纷"
}, {
  "id": "3295",
  "parent": "3245",
  "text": "农业承包合同纠纷"
}, {
  "id": "3296",
  "parent": "3245",
  "text": "林业承包合同纠纷"
}, {
  "id": "3297",
  "parent": "3245",
  "text": "渔业承包合同纠纷"
}, {
  "id": "3298",
  "parent": "3245",
  "text": "牧业承包合同纠纷"
}, {
  "id": "3299",
  "parent": "3245",
  "text": "农村土地承包合同纠纷"
}, {
  "id": "3300",
  "parent": "3245",
  "text": "服务合同纠纷"
}, {
  "id": "3301",
  "parent": "3245",
  "text": "演出合同纠纷"
}, {
  "id": "3302",
  "parent": "3245",
  "text": "劳务合同纠纷"
}, {
  "id": "3303",
  "parent": "3245",
  "text": "离退休人员返聘合同纠纷"
}, {
  "id": "3304",
  "parent": "3245",
  "text": "广告合同纠纷"
}, {
  "id": "3305",
  "parent": "3245",
  "text": "展览合同纠纷"
}, {
  "id": "3306",
  "parent": "3245",
  "text": "追偿权纠纷"
}, {
  "id": "3307",
  "parent": "3245",
  "text": "请求确认人民调解协议效力"
}, {
  "id": "3308",
  "parent": "3210",
  "text": "不当得利纠纷"
}, {
  "id": "3309",
  "parent": "3210",
  "text": "无因管理纠纷"
}, {
  "id": "3211",
  "parent": "3206",
  "text": "知识产权与竞争"
}, {
  "id": "3310",
  "parent": "3211",
  "text": "知识产权合同纠纷"
}, {
  "id": "3311",
  "parent": "3211",
  "text": "知识产权权属、侵权纠纷"
}, {
  "id": "3312",
  "parent": "3211",
  "text": "不正当竞争纠纷"
}, {
  "id": "3313",
  "parent": "3211",
  "text": "垄断纠纷"
}, {
  "id": "3212",
  "parent": "3206",
  "text": "劳动争议、人事争议"
}, {
  "id": "3314",
  "parent": "3212",
  "text": "劳动争议"
}, {
  "id": "3315",
  "parent": "3212",
  "text": "人事争议"
}, {
  "id": "3213",
  "parent": "3206",
  "text": "海事海商"
}, {
  "id": "3214",
  "parent": "3206",
  "text": "与公司、证券、保险、票据有关案件"
}, {
  "id": "3316",
  "parent": "3214",
  "text": "与企业有关的纠纷"
}, {
  "id": "3317",
  "parent": "3214",
  "text": "与公司有关的纠纷"
}, {
  "id": "3318",
  "parent": "3214",
  "text": "合伙企业纠纷"
}, {
  "id": "3319",
  "parent": "3214",
  "text": "与破产有关的纠纷"
}, {
  "id": "3320",
  "parent": "3214",
  "text": "证券纠纷"
}, {
  "id": "3321",
  "parent": "3214",
  "text": "期货交易纠纷"
}, {
  "id": "3322",
  "parent": "3214",
  "text": "信托纠纷"
}, {
  "id": "3323",
  "parent": "3214",
  "text": "保险纠纷"
}, {
  "id": "3324",
  "parent": "3214",
  "text": "票据纠纷"
}, {
  "id": "3325",
  "parent": "3214",
  "text": "信用证纠纷"
}, {
  "id": "3215",
  "parent": "3206",
  "text": "侵权"
}, {
  "id": "3326",
  "parent": "3215",
  "text": "侵权责任纠纷"
}, {
  "id": "3327",
  "parent": "3326",
  "text": "监护人责任纠纷"
}, {
  "id": "3328",
  "parent": "3326",
  "text": "用人单位责任纠纷"
}, {
  "id": "3329",
  "parent": "3326",
  "text": "劳务派遣工作人员侵权责任纠纷"
}, {
  "id": "3330",
  "parent": "3326",
  "text": "提供劳务者致害责任纠纷"
}, {
  "id": "3331",
  "parent": "3326",
  "text": "提供劳务者受害责任纠纷"
}, {
  "id": "3332",
  "parent": "3326",
  "text": "网络侵权责任纠纷"
}, {
  "id": "3333",
  "parent": "3326",
  "text": "违反安全保障义务责任纠纷"
}, {
  "id": "3334",
  "parent": "3326",
  "text": "教育机构责任纠纷"
}, {
  "id": "3335",
  "parent": "3326",
  "text": "产品责任纠纷"
}, {
  "id": "3336",
  "parent": "3326",
  "text": "机动车交通事故责任纠纷"
}, {
  "id": "3337",
  "parent": "3326",
  "text": "医疗损害责任纠纷"
}, {
  "id": "3338",
  "parent": "3326",
  "text": "环境污染责任纠纷"
}, {
  "id": "3339",
  "parent": "3326",
  "text": "高度危险责任纠纷"
}, {
  "id": "3340",
  "parent": "3326",
  "text": "饲养动物损害责任纠纷"
}, {
  "id": "3341",
  "parent": "3326",
  "text": "物件损害责任纠纷"
}, {
  "id": "3342",
  "parent": "3326",
  "text": "触电人身损害责任纠纷"
}, {
  "id": "3343",
  "parent": "3326",
  "text": "义务帮工人受害责任纠纷"
}, {
  "id": "3344",
  "parent": "3326",
  "text": "见义勇为人受害责任纠纷"
}, {
  "id": "3345",
  "parent": "3326",
  "text": "公证损害责任纠纷"
}, {
  "id": "3346",
  "parent": "3326",
  "text": "防卫过当损害责任纠纷"
}, {
  "id": "3347",
  "parent": "3326",
  "text": "紧急避险损害责任纠纷"
}, {
  "id": "3348",
  "parent": "3326",
  "text": "驻香港、澳门特别行政区军人执行职务侵权责任纠纷"
}, {
  "id": "3349",
  "parent": "3326",
  "text": "铁路运输损害责任纠纷"
}, {
  "id": "3350",
  "parent": "3326",
  "text": "水上运输损害责任纠纷"
}, {
  "id": "3351",
  "parent": "3326",
  "text": "航空运输损害责任纠纷"
}, {
  "id": "3352",
  "parent": "3326",
  "text": "因申请诉前财产保全损害责任纠纷"
}, {
  "id": "3353",
  "parent": "3326",
  "text": "因申请诉前证据保全损害责任纠纷"
}, {
  "id": "3354",
  "parent": "3326",
  "text": "因申请诉中财产保全损害责任纠纷"
}, {
  "id": "3355",
  "parent": "3326",
  "text": "因申请诉中证据保全损害责任纠纷"
}, {
  "id": "3356",
  "parent": "3326",
  "text": "因申请先予执行损害责任纠纷"
}, {
  "id": "3216",
  "parent": "3206",
  "text": "特殊程序"
}, {
  "id": "3357",
  "parent": "3216",
  "text": "选民资���案件"
}, {
  "id": "3358",
  "parent": "3216",
  "text": "宣告失踪、宣告死亡案件"
}, {
  "id": "3359",
  "parent": "3216",
  "text": "认定公民无民事行为能力、限制民事行为能力案件"
}, {
  "id": "3360",
  "parent": "3216",
  "text": "认定财产无主案件"
}, {
  "id": "3361",
  "parent": "3216",
  "text": "监护权特别程序案件"
}, {
  "id": "3362",
  "parent": "3216",
  "text": "督促程序案件"
}, {
  "id": "3363",
  "parent": "3216",
  "text": "公示催告程序案件"
}, {
  "id": "3364",
  "parent": "3216",
  "text": "申请诉前停止侵害知识产权案件"
}, {
  "id": "3365",
  "parent": "3216",
  "text": "海事诉讼特别程序案件"
}, {
  "id": "3369",
  "parent": "3206",
  "text": "支付令"
}, {
  "id": "3217",
  "parent": "3206",
  "text": "国内涉外仲裁裁决"
}, {
  "id": "3218",
  "parent": "3206",
  "text": "国内非涉外仲裁裁决"
}, {
  "id": "3219",
  "parent": "3206",
  "text": "公证债权文书"
}, {
  "id": "3220",
  "parent": "3206",
  "text": "经司法确认的调解协议"
}, {
  "id": "3370",
  "parent": "3206",
  "text": "实现担保物权裁定"
}, {
  "id": "3221",
  "parent": "3206",
  "text": "司法协助"
}, {
  "id": "3222",
  "parent": "3221",
  "text": "外国法院民事判决"
}, {
  "id": "3223",
  "parent": "3221",
  "text": "外国仲裁裁决"
}, {
  "id": "3224",
  "parent": "3221",
  "text": "香港法院民事判决"
}, {
  "id": "3225",
  "parent": "3221",
  "text": "香港仲裁裁决"
}, {
  "id": "3226",
  "parent": "3221",
  "text": "澳门法院民事判决"
}, {
  "id": "3227",
  "parent": "3221",
  "text": "澳门仲裁裁决"
}, {
  "id": "3228",
  "parent": "3221",
  "text": "台湾（地区）法院民事判决"
}, {
  "id": "3229",
  "parent": "3221",
  "text": "台湾（地区）仲裁裁决"
}, {
  "id": "3230",
  "parent": "3200",
  "text": "行政"
}, {
  "id": "3231",
  "parent": "3200",
  "text": "行政非诉执行"
}, {
  "id": "3232",
  "parent": "3200",
  "text": "妨碍诉讼行为制裁决定、民事违法制裁决定"
}, {
  "id": "3233",
  "parent": "3200",
  "text": "对下级法院执行异议裁定的复议"
}, {
  "id": "3366",
  "parent": "3200",
  "text": "财产保全"
}, {
  "id": "3367",
  "parent": "3200",
  "text": "先予执行"
}, {
  "id": "3368",
  "parent": "3200",
  "text": "其他案由"
}, {
  "id": "2100",
  "parent": "#",
  "text": "国家赔偿案由"
}, {
  "id": "2101",
  "parent": "2100",
  "text": "刑事赔偿"
}, {
  "id": "2102",
  "parent": "2101",
  "text": "违法刑事拘留赔偿"
}, {
  "id": "2118",
  "parent": "2101",
  "text": "错误刑事拘留赔偿"
}, {
  "id": "2103",
  "parent": "2101",
  "text": "超期刑事拘留赔偿"
}, {
  "id": "2104",
  "parent": "2101",
  "text": "无罪逮捕赔偿"
}, {
  "id": "2119",
  "parent": "2101",
  "text": "错误逮捕赔偿"
}, {
  "id": "2105",
  "parent": "2101",
  "text": "二审无罪赔偿"
}, {
  "id": "2120",
  "parent": "2101",
  "text": "错捕错判共同赔偿"
}, {
  "id": "2106",
  "parent": "2101",
  "text": "重审无罪赔偿"
}, {
  "id": "2107",
  "parent": "2101",
  "text": "再审无罪赔偿"
}, {
  "id": "2121",
  "parent": "2101",
  "text": "再审改判无罪赔偿"
}, {
  "id": "2108",
  "parent": "2101",
  "text": "刑讯逼供致伤、致死赔偿"
}, {
  "id": "2122",
  "parent": "2101",
  "text": "刑讯逼供致人伤害、死亡赔偿"
}, {
  "id": "2109",
  "parent": "2101",
  "text": "殴打、虐待致伤、致死赔偿"
}, {
  "id": "2123",
  "parent": "2101",
  "text": "使用暴力、唆使她人使用暴力致人伤害、死亡赔偿"
}, {
  "id": "2110",
  "parent": "2101",
  "text": "违法使用武器、警械致伤、致死赔偿"
}, {
  "id": "2124",
  "parent": "2101",
  "text": "违法使用武器、警械致人伤害、死亡赔偿"
}, {
  "id": "2111",
  "parent": "2101",
  "text": "刑事违法查封、扣押、冻结、追缴赔偿"
}, {
  "id": "2112",
  "parent": "2101",
  "text": "错判罚金、没收财产赔偿"
}, {
  "id": "2113",
  "parent": "2100",
  "text": "非刑事赔偿"
}, {
  "id": "2114",
  "parent": "2113",
  "text": "违法司法罚款赔偿"
}, {
  "id": "2115",
  "parent": "2113",
  "text": "违法司法拘留赔偿"
}, {
  "id": "2116",
  "parent": "2113",
  "text": "违法保全赔偿"
}, {
  "id": "2125",
  "parent": "2113",
  "text": "违法查封、扣押、冻结赔偿"
}, {
  "id": "2117",
  "parent": "2113",
  "text": "错误执行赔偿"
}, {
  "id": "xzay",
  "parent": "#",
  "text": "行政案由"
}, {
  "id": "xzzt",
  "parent": "xzay",
  "text": "行政主体"
}, {
  "id": "xzxw",
  "parent": "xzay",
  "text": "行政行为"
}, {
  "id": "xz0100",
  "parent": "xzzt",
  "text": "公安行政管理"
}, {
  "id": "xz0101",
  "parent": "xzzt",
  "text": "治安管理（治安）"
}, {
  "id": "xz0102",
  "parent": "xzzt",
  "text": "消防管理（消防）"
}, {
  "id": "xz0103",
  "parent": "xzzt",
  "text": "道路交通管理（道路）"
}, {
  "id": "xz0190",
  "parent": "xzzt",
  "text": "其他（公安）"
}, {
  "id": "xz0200",
  "parent": "xzzt",
  "text": "资源行政管理"
}, {
  "id": "xz0201",
  "parent": "xzzt",
  "text": "土地行政管理（土地）"
}, {
  "id": "xz0202",
  "parent": "xzzt",
  "text": "林业行政管理（林业）"
}, {
  "id": "xz0203",
  "parent": "xzzt",
  "text": "草原行政管理（草原）"
}, {
  "id": "xz0204",
  "parent": "xzzt",
  "text": "地质矿产行政管理（地矿）"
}, {
  "id": "xz0205",
  "parent": "xzzt",
  "text": "能源行政管理（能源管理）"
}, {
  "id": "xz0290",
  "parent": "xzzt",
  "text": "其他（资源）"
}, {
  "id": "xz0300",
  "parent": "xzzt",
  "text": "城乡建设行政管理"
}, {
  "id": "xz0301",
  "parent": "xzzt",
  "text": "城市规划管理（规划）"
}, {
  "id": "xz0302",
  "parent": "xzzt",
  "text": "房屋拆迁管理（拆迁）"
}, {
  "id": "xz0303",
  "parent": "xzzt",
  "text": "房屋登记管理（房屋登记）"
}, {
  "id": "xz0390",
  "parent": "xzzt",
  "text": "其他（城建）"
}, {
  "id": "xz0400",
  "parent": "xzzt",
  "text": "计划生育行政管理（计划生育）"
}, {
  "id": "xz0500",
  "parent": "xzzt",
  "text": "工商行政管理（工商）"
}, {
  "id": "xz0600",
  "parent": "xzzt",
  "text": "商标行政管理（商标）"
}, {
  "id": "xz0700",
  "parent": "xzzt",
  "text": "质量监督检验检疫行政管理"
}, {
  "id": "xz0701",
  "parent": "xzzt",
  "text": "质量监督行政管理（质量监督）"
}, {
  "id": "xz0702",
  "parent": "xzzt",
  "text": "质量检验行政管理（质量检验）"
}, {
  "id": "xz0703",
  "parent": "xzzt",
  "text": "检疫行政管理（检疫）"
}, {
  "id": "xz0790",
  "parent": "xzzt",
  "text": "其他（质量监督）"
}, {
  "id": "xz0800",
  "parent": "xzzt",
  "text": "卫生行政管理（卫生）"
}, {
  "id": "xz0900",
  "parent": "xzzt",
  "text": "食品药品安全行政管理（食品、药品）"
}, {
  "id": "xz1000",
  "parent": "xzzt",
  "text": "农业行政管理（农业）"
}, {
  "id": "xz1001",
  "parent": "xzzt",
  "text": "渔业行政管理（渔业）"
}, {
  "id": "xz1002",
  "parent": "xzzt",
  "text": "畜牧行政管理（畜牧）"
}, {
  "id": "xz1090",
  "parent": "xzzt",
  "text": "其他（农业）"
}, {
  "id": "xz1100",
  "parent": "xzzt",
  "text": "物价行政管理（物价）"
}, {
  "id": "xz1200",
  "parent": "xzzt",
  "text": "环境保护行政管理（环保）"
}, {
  "id": "xz1300",
  "parent": "xzzt",
  "text": "交通运输行政管理（交通）"
}, {
  "id": "xz1301",
  "parent": "xzzt",
  "text": "公路交通行政管理（公路）"
}, {
  "id": "xz1302",
  "parent": "xzzt",
  "text": "铁路行政管理（铁路）"
}, {
  "id": "xz1303",
  "parent": "xzzt",
  "text": "航空行政管理（航空）"
}, {
  "id": "xz1390",
  "parent": "xzzt",
  "text": "其他（交通）"
}, {
  "id": "xz1400",
  "parent": "xzzt",
  "text": "信息电讯行政管理（信息、电讯）"
}, {
  "id": "xz1500",
  "parent": "xzzt",
  "text": "邮政行政管理（邮政）"
}, {
  "id": "xz1600",
  "parent": "xzzt",
  "text": "专利行政管理（专利）"
}, {
  "id": "xz1700",
  "parent": "xzzt",
  "text": "新闻出版行政管理（新闻、出版）"
}, {
  "id": "xz1800",
  "parent": "xzzt",
  "text": "税务行政管理（税务）"
}, {
  "id": "xz1900",
  "parent": "xzzt",
  "text": "金融行政管理（金融）"
}, {
  "id": "xz2000",
  "parent": "xzzt",
  "text": "外汇行政管理（外汇）"
}, {
  "id": "xz2100",
  "parent": "xzzt",
  "text": "海关行政管理（海关）"
}, {
  "id": "xz2200",
  "parent": "xzzt",
  "text": "财政行政管理（财政）"
}, {
  "id": "xz2300",
  "parent": "xzzt",
  "text": "劳动和社会保障行政管理（劳动、社会保障）"
}, {
  "id": "xz2400",
  "parent": "xzzt",
  "text": "审计行政管理（审计）"
}, {
  "id": "xz2500",
  "parent": "xzzt",
  "text": "经贸行政管理（内贸、外贸）"
}, {
  "id": "xz2600",
  "parent": "xzzt",
  "text": "水利行政管理（水利）"
}, {
  "id": "xz2700",
  "parent": "xzzt",
  "text": "旅游行政管理（旅游）"
}, {
  "id": "xz2800",
  "parent": "xzzt",
  "text": "烟草专卖行政管理（烟草专卖）"
}, {
  "id": "xz2900",
  "parent": "xzzt",
  "text": "司法行政管理（司法行政）"
}, {
  "id": "xz3000",
  "parent": "xzzt",
  "text": "民政行政管理（民政）"
}, {
  "id": "xz3100",
  "parent": "xzzt",
  "text": "教育行政管理（教育）"
}, {
  "id": "xz3200",
  "parent": "xzzt",
  "text": "文化行政管理（文化）"
}, {
  "id": "xz3300",
  "parent": "xzzt",
  "text": "广播电视电影行政管理（广电）"
}, {
  "id": "xz3400",
  "parent": "xzzt",
  "text": "统计行政管理（统计）"
}, {
  "id": "xz3500",
  "parent": "xzzt",
  "text": "电力行政管理（电力）"
}, {
  "id": "xz3600",
  "parent": "xzzt",
  "text": "国有资产行政管理（国资）"
}, {
  "id": "xz3700",
  "parent": "xzzt",
  "text": "外资行政管理（外资管理）"
}, {
  "id": "xz3800",
  "parent": "xzzt",
  "text": "盐业行政管理（盐业）"
}, {
  "id": "xz3900",
  "parent": "xzzt",
  "text": "体育行政管理（体育）"
}, {
  "id": "xz4000",
  "parent": "xzzt",
  "text": "行政监察（监察）"
}, {
  "id": "xz4100",
  "parent": "xzzt",
  "text": "乡政府"
}, {
  "id": "xz9000",
  "parent": "xzzt",
  "text": "其他行政管理"
}, {
  "id": "xz1",
  "parent": "xzxw",
  "text": "行政处罚"
}, {
  "id": "xz2",
  "parent": "xzxw",
  "text": "行政强制"
}, {
  "id": "xz3",
  "parent": "xzxw",
  "text": "行政裁决"
}, {
  "id": "xz4",
  "parent": "xzxw",
  "text": "行政确认"
}, {
  "id": "xz5",
  "parent": "xzxw",
  "text": "行政登记"
}, {
  "id": "xz6",
  "parent": "xzxw",
  "text": "行政许可"
}, {
  "id": "xz7",
  "parent": "xzxw",
  "text": "行政批准"
}, {
  "id": "xz8",
  "parent": "xzxw",
  "text": "行政命令"
}, {
  "id": "xz9",
  "parent": "xzxw",
  "text": "行政复议"
}, {
  "id": "xz10",
  "parent": "xzxw",
  "text": "行政撤销"
}, {
  "id": "xz11",
  "parent": "xzxw",
  "text": "行政检查"
}, {
  "id": "xz12",
  "parent": "xzxw",
  "text": "行政合同"
}, {
  "id": "xz13",
  "parent": "xzxw",
  "text": "行政奖励"
}, {
  "id": "xz14",
  "parent": "xzxw",
  "text": "行政补偿"
}, {
  "id": "xz15",
  "parent": "xzxw",
  "text": "行政执行"
}, {
  "id": "xz16",
  "parent": "xzxw",
  "text": "行政受理"
}, {
  "id": "xz17",
  "parent": "xzxw",
  "text": "行政给付"
}, {
  "id": "xz18",
  "parent": "xzxw",
  "text": "行政征用"
}, {
  "id": "xz19",
  "parent": "xzxw",
  "text": "行政征购"
}, {
  "id": "xz20",
  "parent": "xzxw",
  "text": "行政征收"
}, {
  "id": "xz21",
  "parent": "xzxw",
  "text": "行政划拔"
}, {
  "id": "xz22",
  "parent": "xzxw",
  "text": "行政规划"
}, {
  "id": "xz23",
  "parent": "xzxw",
  "text": "行政救助"
}, {
  "id": "xz24",
  "parent": "xzxw",
  "text": "行政协助"
}, {
  "id": "xz25",
  "parent": "xzxw",
  "text": "行政允诺"
}, {
  "id": "xz26",
  "parent": "xzxw",
  "text": "行政监督"
}, {
  "id": "xz255",
  "parent": "xzxw",
  "text": "其他行政行为"
}, {
  "id": "8000",
  "parent": "9000",
  "text": "(2008-2011)——历史案由"
}, {
  "id": "8001",
  "parent": "8000",
  "text": "人格权纠纷"
}, {
  "id": "8003",
  "parent": "8001",
  "text": "生命权、健康权、身体权纠纷"
}, {
  "id": "8004",
  "parent": "8003",
  "text": "道路交通事故人身损害赔偿纠纷"
}, {
  "id": "8005",
  "parent": "8003",
  "text": "医疗损害赔偿纠纷"
}, {
  "id": "8006",
  "parent": "8003",
  "text": "工伤事故损害赔偿纠纷"
}, {
  "id": "8007",
  "parent": "8003",
  "text": "水上运输人身损害赔偿纠纷"
}, {
  "id": "8008",
  "parent": "8003",
  "text": "航空运输人身损害赔偿纠纷"
}, {
  "id": "8009",
  "parent": "8003",
  "text": "航空器对地、水面上第三人损害赔偿纠纷"
}, {
  "id": "8010",
  "parent": "8003",
  "text": "触电人身损害赔偿纠纷"
}, {
  "id": "8019",
  "parent": "8000",
  "text": "婚姻家庭、继承纠纷"
}, {
  "id": "8020",
  "parent": "8019",
  "text": "婚姻家庭纠纷"
}, {
  "id": "8025",
  "parent": "8020",
  "text": "同居关系析产、子女抚养纠纷"
}, {
  "id": "8067",
  "parent": "8000",
  "text": "所有权纠纷"
}, {
  "id": "8069",
  "parent": "8067",
  "text": "建筑物区分所有权纠纷"
}, {
  "id": "8072",
  "parent": "8069",
  "text": "车位、车库纠纷"
}, {
  "id": "8078",
  "parent": "8067",
  "text": "相邻关系纠纷"
}, {
  "id": "8082",
  "parent": "8078",
  "text": "相邻通风、采光和日照纠纷"
}, {
  "id": "8085",
  "parent": "8067",
  "text": "共有纠纷"
}, {
  "id": "8086",
  "parent": "8085",
  "text": "按份共有纠纷"
}, {
  "id": "8087",
  "parent": "8085",
  "text": "共同共有纠纷"
}, {
  "id": "8131",
  "parent": "8000",
  "text": "合同纠纷"
}, {
  "id": "8144",
  "parent": "8131",
  "text": "房屋买卖合同纠纷"
}, {
  "id": "8147",
  "parent": "8131",
  "text": "房地产开发经营合同纠纷"
}, {
  "id": "8148",
  "parent": "8147",
  "text": "商品房预售合同纠纷"
}, {
  "id": "8149",
  "parent": "8147",
  "text": "商品房销售合同纠纷"
}, {
  "id": "8150",
  "parent": "8147",
  "text": "商品房委托代理销售合同纠纷"
}, {
  "id": "8151",
  "parent": "8147",
  "text": "委托代建合同纠纷"
}, {
  "id": "8152",
  "parent": "8147",
  "text": "建设用地使用权出让合同纠纷"
}, {
  "id": "8153",
  "parent": "8147",
  "text": "土地租赁合同纠纷"
}, {
  "id": "8154",
  "parent": "8147",
  "text": "临时用地合同纠纷"
}, {
  "id": "8155",
  "parent": "8147",
  "text": "合资、合作开发房地产合同纠纷"
}, {
  "id": "8156",
  "parent": "8147",
  "text": "项目转让合同纠纷"
}, {
  "id": "8157",
  "parent": "8147",
  "text": "房屋拆迁安置补偿合同纠纷"
}, {
  "id": "8158",
  "parent": "8131",
  "text": "供用电、水、气、热力合同纠纷"
}, {
  "id": "8171",
  "parent": "8131",
  "text": "担保追偿权纠纷"
}, {
  "id": "8175",
  "parent": "8131",
  "text": "租赁合同纠纷"
}, {
  "id": "8177",
  "parent": "8175",
  "text": "承租人优先购买权纠纷"
}, {
  "id": "8201",
  "parent": "8131",
  "text": "委托合同纠纷"
}, {
  "id": "8206",
  "parent": "8201",
  "text": "委托理财合同纠纷"
}, {
  "id": "8211",
  "parent": "8131",
  "text": "保险合同纠纷"
}, {
  "id": "8212",
  "parent": "8211",
  "text": "财产保险合同纠纷"
}, {
  "id": "8213",
  "parent": "8211",
  "text": "人身保险合同纠纷"
}, {
  "id": "8214",
  "parent": "8211",
  "text": "机动车交通事故责任强制保险合同纠纷"
}, {
  "id": "8215",
  "parent": "8211",
  "text": "保证保险合同纠纷"
}, {
  "id": "8216",
  "parent": "8211",
  "text": "再保险合同纠纷"
}, {
  "id": "8217",
  "parent": "8211",
  "text": "保险代位求偿权纠纷"
}, {
  "id": "8218",
  "parent": "8211",
  "text": "保险经纪合同纠纷"
}, {
  "id": "8250",
  "parent": "8131",
  "text": "劳务（雇佣）合同纠纷"
}, {
  "id": "8252",
  "parent": "8131",
  "text": "人民调解协议纠纷"
}, {
  "id": "8253",
  "parent": "8252",
  "text": "请求履行人民调解协议纠纷"
}, {
  "id": "8254",
  "parent": "8252",
  "text": "请求变更人民调解协议纠纷"
}, {
  "id": "8255",
  "parent": "8252",
  "text": "请求撤销人民调解协议纠纷"
}, {
  "id": "8256",
  "parent": "8252",
  "text": "请求确认人民调解协议无效纠纷"
}, {
  "id": "8130",
  "parent": "8000",
  "text": "债权纠纷"
}, {
  "id": "8257",
  "parent": "8130",
  "text": "特殊类型的侵权纠纷"
}, {
  "id": "8260",
  "parent": "8257",
  "text": "环境污染侵权纠纷"
}, {
  "id": "8261",
  "parent": "8257",
  "text": "大气污染侵权纠纷"
}, {
  "id": "8262",
  "parent": "8257",
  "text": "水污染侵权纠纷"
}, {
  "id": "8263",
  "parent": "8257",
  "text": "噪声污染侵权纠纷"
}, {
  "id": "8264",
  "parent": "8257",
  "text": "放射性污染侵权纠纷"
}, {
  "id": "8265",
  "parent": "8257",
  "text": "地面、公共场所施工损害赔偿纠纷"
}, {
  "id": "8266",
  "parent": "8257",
  "text": "建筑物、搁置物、悬挂物塌落损害赔偿纠纷"
}, {
  "id": "8268",
  "parent": "8257",
  "text": "国家机关及其工作人员职务侵权纠纷"
}, {
  "id": "8269",
  "parent": "8257",
  "text": "雇员受害赔偿纠纷"
}, {
  "id": "8270",
  "parent": "8257",
  "text": "雇主损害赔偿纠纷"
}, {
  "id": "8281",
  "parent": "8000",
  "text": "知识产权纠纷"
}, {
  "id": "8341",
  "parent": "8281",
  "text": "著作权权属、侵权纠纷"
}, {
  "id": "8343",
  "parent": "8341",
  "text": "侵犯著作人身权纠纷"
}, {
  "id": "8344",
  "parent": "8341",
  "text": "侵犯著作财产权纠纷"
}, {
  "id": "8345",
  "parent": "8341",
  "text": "邻接权权属纠纷"
}, {
  "id": "8373",
  "parent": "8281",
  "text": "侵犯特殊标志专有权纠纷"
}, {
  "id": "8374",
  "parent": "8373",
  "text": "侵犯奥林匹克标志专有权纠纷"
}, {
  "id": "8375",
  "parent": "8373",
  "text": "侵犯世界博览会标志专有权纠纷"
}, {
  "id": "8376",
  "parent": "8281",
  "text": "计算机网络域名权属、侵权纠纷"
}, {
  "id": "8377",
  "parent": "8376",
  "text": "计算机网络域名权属纠纷"
}, {
  "id": "8378",
  "parent": "8376",
  "text": "侵犯计算机网络域名纠纷"
}, {
  "id": "8382",
  "parent": "8281",
  "text": "确认不侵权纠纷"
}, {
  "id": "8383",
  "parent": "8382",
  "text": "确认不侵犯专利权纠纷"
}, {
  "id": "8384",
  "parent": "8382",
  "text": "确认不侵犯注册商标专用权纠纷"
}, {
  "id": "8385",
  "parent": "8382",
  "text": "确认不侵犯著作权纠纷"
}, {
  "id": "8386",
  "parent": "8382",
  "text": "因申请临时措施损害赔偿纠纷"
}, {
  "id": "8387",
  "parent": "8281",
  "text": "不正当竞争、垄断纠纷"
}, {
  "id": "8397",
  "parent": "8387",
  "text": "侵犯商业秘密竞业限制纠纷"
}, {
  "id": "8398",
  "parent": "8387",
  "text": "倾销纠纷"
}, {
  "id": "8399",
  "parent": "8387",
  "text": "搭售、附加不合理条件销售纠纷"
}, {
  "id": "8402",
  "parent": "8387",
  "text": "串通投标纠纷"
}, {
  "id": "8404",
  "parent": "8000",
  "text": "劳动争议、人事争议"
}, {
  "id": "8413",
  "parent": "8404",
  "text": "社会保险纠纷"
}, {
  "id": "8414",
  "parent": "8413",
  "text": "养老金纠纷"
}, {
  "id": "8416",
  "parent": "8413",
  "text": "医疗费、医疗保险待遇纠纷"
}, {
  "id": "8420",
  "parent": "8404",
  "text": "人事争议"
}, {
  "id": "8424",
  "parent": "8420",
  "text": "聘任、聘用合同争议"
}, {
  "id": "8425",
  "parent": "8000",
  "text": "海事海商纠纷"
}, {
  "id": "8430",
  "parent": "8425",
  "text": "船舶污染损害赔偿纠纷"
}, {
  "id": "8431",
  "parent": "8425",
  "text": "海上、通海水域污染损害赔偿纠纷"
}, {
  "id": "8432",
  "parent": "8425",
  "text": "养殖损害赔偿纠纷"
}, {
  "id": "8433",
  "parent": "8425",
  "text": "海上财产损害赔偿纠纷"
}, {
  "id": "8434",
  "parent": "8425",
  "text": "海上人身损害赔偿纠纷"
}, {
  "id": "8435",
  "parent": "8425",
  "text": "非法留置船舶、船载货物和船用燃油、船用物料损害赔偿纠纷"
}, {
  "id": "8436",
  "parent": "8425",
  "text": "海上、通海水域货物运输合同纠纷"
}, {
  "id": "8438",
  "parent": "8425",
  "text": "海上、通海水域旅客和行李运输合同纠纷"
}, {
  "id": "8440",
  "parent": "8425",
  "text": "船舶买卖(建造、修理、改建和拆解)合同纠纷"
}, {
  "id": "8449",
  "parent": "8425",
  "text": "船舶属具和海运集装箱租赁、保管合同纠纷"
}, {
  "id": "8452",
  "parent": "8425",
  "text": "货运代理合同纠纷"
}, {
  "id": "8454",
  "parent": "8425",
  "text": "船舶物料、备品供应合同纠纷"
}, {
  "id": "8456",
  "parent": "8425",
  "text": "海难救助、海上打捞合同纠纷"
}, {
  "id": "8457",
  "parent": "8425",
  "text": "拖航合同纠纷"
}, {
  "id": "8460",
  "parent": "8425",
  "text": "与船舶营运有关的借款合同纠纷"
}, {
  "id": "8463",
  "parent": "8425",
  "text": "船坞建造合同纠纷"
}, {
  "id": "8464",
  "parent": "8425",
  "text": "码头建造合同纠纷"
}, {
  "id": "8475",
  "parent": "8000",
  "text": "与铁路运输有关的民事纠纷"
}, {
  "id": "8478",
  "parent": "8475",
  "text": "铁路旅客、行李、包裹运输合同纠纷"
}, {
  "id": "8479",
  "parent": "8475",
  "text": "多式联运合同纠纷（由铁路法院受理的）"
}, {
  "id": "8480",
  "parent": "8475",
  "text": "国际铁路联运合同纠纷"
}, {
  "id": "8481",
  "parent": "8475",
  "text": "铁路货物、旅客、行李、包裹运输保险合同纠纷"
}, {
  "id": "8482",
  "parent": "8475",
  "text": "铁路运输延伸服务合同纠纷"
}, {
  "id": "8485",
  "parent": "8475",
  "text": "损害铁路赔偿纠纷"
}, {
  "id": "8486",
  "parent": "8475",
  "text": "铁路运输人身、财产损害赔偿纠纷"
}, {
  "id": "8487",
  "parent": "8475",
  "text": "铁路电信服务合同纠纷"
}, {
  "id": "8488",
  "parent": "8475",
  "text": "铁路机车、车辆建造合同纠纷"
}, {
  "id": "8489",
  "parent": "8000",
  "text": "与公司、证券、票据等有关的民事纠纷"
}, {
  "id": "8507",
  "parent": "8489",
  "text": "与公司有关的纠纷"
}, {
  "id": "8508",
  "parent": "8507",
  "text": "股权确认纠纷"
}, {
  "id": "8509",
  "parent": "8507",
  "text": "股东名册变更纠纷"
}, {
  "id": "8511",
  "parent": "8507",
  "text": "公司章程或章程条款撤销纠纷"
}, {
  "id": "8516",
  "parent": "8507",
  "text": "股东会或者股东大会、董事会决议效力纠纷"
}, {
  "id": "8517",
  "parent": "8507",
  "text": "股东会或者股东大会、董事会决议效力确认纠纷"
}, {
  "id": "8518",
  "parent": "8507",
  "text": "股东会或者股东大会、董事会决议撤销纠纷"
}, {
  "id": "8520",
  "parent": "8507",
  "text": "股东滥用股东权利赔偿纠纷"
}, {
  "id": "8521",
  "parent": "8507",
  "text": "股东滥用公司法人独立地位和股东有限责任赔偿纠纷"
}, {
  "id": "8522",
  "parent": "8507",
  "text": "董事、高级管理人员损害股东利益赔偿纠纷"
}, {
  "id": "8523",
  "parent": "8507",
  "text": "公司的控股股东、实际控制人、董事、监事、高级管理人员损害公司利益赔偿纠纷"
}, {
  "id": "8524",
  "parent": "8507",
  "text": "清算组成员责任纠纷"
}, {
  "id": "8530",
  "parent": "8507",
  "text": "公司清算纠纷"
}, {
  "id": "8532",
  "parent": "8489",
  "text": "与合伙企业有关的纠纷"
}, {
  "id": "8533",
  "parent": "8532",
  "text": "普通合伙纠纷"
}, {
  "id": "8534",
  "parent": "8532",
  "text": "特殊的普通合伙纠纷"
}, {
  "id": "8535",
  "parent": "8532",
  "text": "有限合伙纠纷"
}, {
  "id": "8536",
  "parent": "8489",
  "text": "与破产有关的纠纷"
}, {
  "id": "8540",
  "parent": "8536",
  "text": "职工权益清单更正纠纷"
}, {
  "id": "8543",
  "parent": "8536",
  "text": "抵销权纠纷"
}, {
  "id": "8546",
  "parent": "8489",
  "text": "证券纠纷"
}, {
  "id": "8551",
  "parent": "8546",
  "text": "证券衍生品种交易纠纷"
}, {
  "id": "2999",
  "parent": "2100",
  "text": "其他赔偿"
}, {
  "id": "9999",
  "parent": "9000",
  "text": "其他民事纠纷"
}]
export const a = arrayToThree(b,'parent')



// WEBPACK FOOTER //
// ./src/assets/js/library.js